var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTasheel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 308.6 304.2",
    style: {
      enableBackground: "new 0 0 308.6 304.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_2_);}\r\n\t.st2{fill:url(#SVGID_3_);}\r\n\t.st3{fill:url(#SVGID_4_);}\r\n\t.st4{fill:url(#SVGID_5_);}\r\n\t.st5{fill:url(#SVGID_6_);}\r\n\t.st6{fill:url(#SVGID_7_);}\r\n\t.st7{fill:url(#SVGID_8_);}\r\n\t.st8{fill:url(#SVGID_9_);}\r\n\t.st9{fill:url(#SVGID_10_);}\r\n\t.st10{fill:url(#SVGID_11_);}\r\n\t.st11{fill:url(#SVGID_12_);}\r\n\t.st12{fill:url(#SVGID_13_);}\r\n\t.st13{fill:url(#SVGID_14_);}\r\n\t.st14{fill:url(#SVGID_15_);}\r\n\t.st15{fill:url(#SVGID_16_);}\r\n\t.st16{fill:url(#SVGID_17_);}\r\n\t.st17{fill:url(#SVGID_18_);}\r\n\t.st18{fill:url(#SVGID_19_);}\r\n\t.st19{fill:url(#SVGID_20_);}\r\n\t.st20{fill:url(#SVGID_21_);}\r\n\t.st21{fill:url(#SVGID_22_);}\r\n\t.st22{fill:url(#SVGID_23_);}\r\n\t.st23{fill:url(#SVGID_24_);}\r\n\t.st24{fill:url(#SVGID_25_);}\r\n\t.st25{fill:url(#SVGID_26_);}\r\n\t.st26{fill:url(#SVGID_27_);}\r\n\t.st27{fill:url(#SVGID_28_);}\r\n\t.st28{fill:url(#SVGID_29_);}\r\n\t.st29{fill:url(#SVGID_30_);}\r\n\t.st30{fill:url(#SVGID_31_);}\r\n\t.st31{fill:url(#SVGID_32_);}\r\n\t.st32{fill:url(#SVGID_33_);}\r\n\t.st33{fill:url(#SVGID_34_);}\r\n\t.st34{fill:url(#SVGID_35_);}\r\n\t.st35{fill:url(#SVGID_36_);}\r\n\t.st36{fill:url(#SVGID_37_);}\r\n\t.st37{fill:url(#SVGID_38_);}\r\n\t.st38{fill:url(#SVGID_39_);}\r\n\t.st39{fill:url(#SVGID_40_);}\r\n\t.st40{fill:url(#SVGID_41_);}\r\n\t.st41{fill:url(#SVGID_42_);}\r\n\t.st42{fill:url(#SVGID_43_);}\r\n\t.st43{fill:url(#SVGID_44_);}\r\n\t.st44{fill:url(#SVGID_45_);}\r\n\t.st45{fill:url(#SVGID_46_);}\r\n\t.st46{fill:url(#SVGID_47_);}\r\n\t.st47{fill:url(#SVGID_48_);}\r\n\t.st48{fill:url(#SVGID_49_);}\r\n\t.st49{fill:url(#SVGID_50_);}\r\n\t.st50{fill:url(#SVGID_51_);}\r\n\t.st51{fill:url(#SVGID_52_);}\r\n\t.st52{fill:url(#SVGID_53_);}\r\n\t.st53{fill:url(#SVGID_54_);}\r\n\t.st54{fill:url(#SVGID_55_);}\r\n\t.st55{fill:url(#SVGID_56_);}\r\n\t.st56{fill:url(#SVGID_57_);}\r\n\t.st57{fill:url(#SVGID_58_);}\r\n\t.st58{fill:url(#SVGID_59_);}\r\n\t.st59{fill:url(#SVGID_60_);}\r\n\t.st60{fill:url(#SVGID_61_);}\r\n\t.st61{fill:url(#SVGID_62_);}\r\n\t.st62{fill:url(#SVGID_63_);}\r\n\t.st63{fill:url(#SVGID_64_);}\r\n\t.st64{fill:url(#SVGID_65_);}\r\n\t.st65{fill:url(#SVGID_66_);}\r\n\t.st66{fill:url(#SVGID_67_);}\r\n\t.st67{fill:url(#SVGID_68_);}\r\n\t.st68{fill:url(#SVGID_69_);}\r\n\t.st69{fill:url(#SVGID_70_);}\r\n\t.st70{fill:url(#SVGID_71_);}\r\n\t.st71{fill:url(#SVGID_72_);}\r\n\t.st72{fill:url(#SVGID_73_);}\r\n\t.st73{fill:url(#SVGID_74_);}\r\n\t.st74{fill:url(#SVGID_75_);}\r\n\t.st75{fill:url(#SVGID_76_);}\r\n\t.st76{fill:url(#SVGID_77_);}\r\n\t.st77{fill:url(#SVGID_78_);}\r\n\t.st78{fill:url(#SVGID_79_);}\r\n\t.st79{fill:url(#SVGID_80_);}\r\n\t.st80{fill:url(#SVGID_81_);}\r\n\t.st81{fill:url(#SVGID_82_);}\r\n\t.st82{fill:url(#SVGID_83_);}\r\n\t.st83{fill:url(#SVGID_84_);}\r\n\t.st84{fill:url(#SVGID_85_);}\r\n\t.st85{fill:url(#SVGID_86_);}\r\n\t.st86{fill:url(#SVGID_87_);}\r\n\t.st87{fill:url(#SVGID_88_);}\r\n\t.st88{fill:url(#SVGID_89_);}\r\n\t.st89{fill:url(#SVGID_90_);}\r\n\t.st90{fill:url(#SVGID_91_);}\r\n\t.st91{fill:url(#SVGID_92_);}\r\n\t.st92{fill:url(#SVGID_93_);}\r\n\t.st93{fill:url(#SVGID_94_);}\r\n\t.st94{fill:url(#SVGID_95_);}\r\n\t.st95{fill:url(#SVGID_96_);}\r\n\t.st96{fill:url(#SVGID_97_);}\r\n\t.st97{fill:url(#SVGID_98_);}\r\n\t.st98{fill:url(#SVGID_99_);}\r\n\t.st99{fill:url(#SVGID_100_);}\r\n\t.st100{fill:url(#SVGID_101_);}\r\n\t.st101{fill:url(#SVGID_102_);}\r\n\t.st102{fill:url(#SVGID_103_);}\r\n\t.st103{fill:url(#SVGID_104_);}\r\n\t.st104{fill:url(#SVGID_105_);}\r\n\t.st105{fill:url(#SVGID_106_);}\r\n\t.st106{fill:url(#SVGID_107_);}\r\n\t.st107{fill:url(#SVGID_108_);}\r\n\t.st108{fill:url(#SVGID_109_);}\r\n\t.st109{fill:url(#SVGID_110_);}\r\n\t.st110{fill:url(#SVGID_111_);}\r\n\t.st111{fill:url(#SVGID_112_);}\r\n\t.st112{fill:url(#SVGID_113_);}\r\n\t.st113{fill:url(#SVGID_114_);}\r\n\t.st114{fill:url(#SVGID_115_);}\r\n\t.st115{fill:url(#SVGID_116_);}\r\n\t.st116{fill:url(#SVGID_117_);}\r\n\t.st117{fill:url(#SVGID_118_);}\r\n\t.st118{fill:url(#SVGID_119_);}\r\n\t.st119{fill:url(#SVGID_120_);}\r\n\t.st120{fill:url(#SVGID_121_);}\r\n\t.st121{fill:url(#SVGID_122_);}\r\n\t.st122{fill:url(#SVGID_123_);}\r\n\t.st123{fill:url(#SVGID_124_);}\r\n\t.st124{fill:url(#SVGID_125_);}\r\n\t.st125{fill:url(#SVGID_126_);}\r\n\t.st126{fill:url(#SVGID_127_);}\r\n\t.st127{fill:url(#SVGID_128_);}\r\n\t.st128{fill:url(#SVGID_129_);}\r\n\t.st129{fill:url(#SVGID_130_);}\r\n\t.st130{fill:url(#SVGID_131_);}\r\n\t.st131{fill:url(#SVGID_132_);}\r\n\t.st132{fill:url(#SVGID_133_);}\r\n\t.st133{fill:url(#SVGID_134_);}\r\n\t.st134{fill:url(#SVGID_135_);}\r\n\t.st135{fill:url(#SVGID_136_);}\r\n\t.st136{fill:url(#SVGID_137_);}\r\n\t.st137{fill:url(#SVGID_138_);}\r\n\t.st138{fill:url(#SVGID_139_);}\r\n\t.st139{fill:url(#SVGID_140_);}\r\n\t.st140{fill:url(#SVGID_141_);}\r\n\t.st141{fill:url(#SVGID_142_);}\r\n\t.st142{fill:url(#SVGID_143_);}\r\n\t.st143{fill:url(#SVGID_144_);}\r\n\t.st144{fill:url(#SVGID_145_);}\r\n\t.st145{fill:url(#SVGID_146_);}\r\n\t.st146{fill:url(#SVGID_147_);}\r\n\t.st147{fill:url(#SVGID_148_);}\r\n\t.st148{fill:url(#SVGID_149_);}\r\n\t.st149{fill:url(#SVGID_150_);}\r\n\t.st150{fill:url(#SVGID_151_);}\r\n\t.st151{fill:url(#SVGID_152_);}\r\n\t.st152{fill:url(#SVGID_153_);}\r\n\t.st153{fill:url(#SVGID_154_);}\r\n\t.st154{fill:url(#SVGID_155_);}\r\n\t.st155{fill:url(#SVGID_156_);}\r\n\t.st156{fill:url(#SVGID_157_);}\r\n\t.st157{fill:url(#SVGID_158_);}\r\n\t.st158{fill:url(#SVGID_159_);}\r\n\t.st159{fill:url(#SVGID_160_);}\r\n\t.st160{fill:url(#SVGID_161_);}\r\n\t.st161{fill:url(#SVGID_162_);}\r\n\t.st162{fill:url(#SVGID_163_);}\r\n\t.st163{fill:url(#SVGID_164_);}\r\n\t.st164{fill:url(#SVGID_165_);}\r\n\t.st165{fill:url(#SVGID_166_);}\r\n\t.st166{fill:url(#SVGID_167_);}\r\n\t.st167{fill:url(#SVGID_168_);}\r\n\t.st168{fill:url(#SVGID_169_);}\r\n\t.st169{fill:url(#SVGID_170_);}\r\n\t.st170{fill:url(#SVGID_171_);}\r\n\t.st171{fill:url(#SVGID_172_);}\r\n\t.st172{fill:url(#SVGID_173_);}\r\n\t.st173{fill:url(#SVGID_174_);}\r\n\t.st174{fill:url(#SVGID_175_);}\r\n\t.st175{fill:url(#SVGID_176_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 86.2705,
    y1: 104.9088,
    x2: 125.9971,
    y2: 104.9088
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.7,80.7c1.8-1.5,3.8-2.2,6.1-2.2c1.5-0.4,3.4-1.1,4.4,0.3c1.1,1.5-0.3,3.1-1.1,4.3 c-10,15.6,1.3,37.5,21.6,38.8c1.6,0.1,3.2,0,4.3,1.5c-1.5,3.4-3.2,6.5-6.6,8.4c-21.6-1.6-37.7-22.9-31.9-44.5 C88.1,84.8,88.8,82.5,90.7,80.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 249.6959,
    y1: 149.7341,
    x2: 284.465,
    y2: 149.7341
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M284.5,163.9c0,2.7-0.9,5.1-2.3,7.4c-9.2,4-16.7,0.1-23.4-5.4c-9.8-8.2-11-23.9-6.5-33.7 c1.2-2.6,2.8-4.4,5.5-5.5c2.6-0.4,5.1,0.1,7.4,1.2c1.3,2-0.3,3.4-1.3,4.6c-5.5,6.3-6.5,13.5-2.7,20.6c3.9,7.4,10.5,11.3,19.3,10.2 C281.8,163.2,283.3,162.8,284.5,163.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 140.1902,
    y1: 52.5955,
    x2: 178.2807,
    y2: 52.5955
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M178.3,71.3c-0.8,2.6-2.2,4.7-4.2,6.5c-0.9,0.5-1.9,0.9-3,0.8c-21.4-2.3-37.9-24.3-28-47.6 c0.4-0.9,1.3-1.6,1.9-2.6c3-1.6,6.2-2,9.7-1.8c0.5,2.2-1.2,3.6-2.2,5.3c-9.6,17.4,1.1,36.7,20.9,37.9 C175,69.9,176.9,69.7,178.3,71.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 35.8029,
    y1: 155.5752,
    x2: 73.8483,
    y2: 155.5752
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M39.5,131.8c2.2-1.8,4.7-2.2,7.3-2.2c0.8-0.4,1.6-0.4,2.4-0.1c0.9,2.6-1.1,4.3-2,6.3 c-8.1,16.6,3.1,36,21.4,37.3c1.9,0.1,4.9-1.1,5.3,2.6c-0.9,2.4-2.2,4.6-4.4,5.9c-10.5,1.3-18.1-4.4-24.4-11.5 C34.8,158.9,33.3,145.8,39.5,131.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 142.8143,
    y1: 253.8518,
    x2: 179.3587,
    y2: 253.8518
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M149.3,229.9c0.1-0.3,0.4-0.3,0.7-0.1c0.3-0.1,0.7-0.3,1.1-0.3c1.9,0.1,4.4-1.1,5.5,0.5 c1.2,1.8-0.9,3.5-1.8,5.1c-7.7,14.1-1.2,34,19.3,34.8c1.9,0.1,4.9-0.9,5.3,2.6c-0.4,2.4-1.6,4.4-3.4,6.1c-12.9,0-22.9-5.3-29-16.7 C141,250.9,141.2,240,149.3,229.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 22.2857,
    y1: 169.3081,
    x2: 54.6748,
    y2: 169.3081
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M53.5,190.3c-19.9,3.8-38-20.6-28.7-42.3c2.8,0.3,3.1,2.6,3.2,4.6c0.9,15.1,10,24.7,21.8,32.2 c1.5,0.9,3.2,1.6,4.3,3.1C55,188.8,54.8,189.7,53.5,190.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 90.1637,
    y1: 204.6021,
    x2: 125.9814,
    y2: 204.6021
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M93.8,180.8c1.2-1.2,2.7-1.1,4.2-1.1c1.5-0.5,3.4-1.1,4.3,0.3c1.1,1.5-0.3,3-0.9,4.4c-4,7.7-4.9,15.4-0.9,23.3 c4.2,8.9,11.5,13.1,20.8,14.3c2,0.3,5.5-0.8,4.7,3.5c-0.5,1.9-1.5,3.4-3.1,4.4c-23.2-0.9-37.6-21.2-31-43.3 C92.4,184.7,93.3,182.9,93.8,180.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 140.5709,
    y1: 153.6598,
    x2: 178.0113,
    y2: 153.6598
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M178,173.4c-0.3,1.9-1.5,3.1-2.7,4.4c-3.6,2-7.3,1.5-10.8,0.1c-14-5.3-22.1-15.4-23.9-30.3 c-0.7-6.3,1.8-12.1,4.2-17.9c0.8-1.1,2-1.1,3.2-1.1c1.5-0.5,3.2-1.1,4.4,0.3c1.2,1.5,0.1,3.1-0.7,4.3c-8.4,14.3-0.5,35.8,20.8,38.5 C174.4,172.1,176.5,171.8,178,173.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 148.6644,
    y1: 149.7408,
    x2: 181.1274,
    y2: 149.7408
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M181.1,163.9c0.1,2.7-0.5,5.1-2,7.4c-11.6,1.6-20.6-2.7-26.8-12.4c-5.4-8.5-4.6-20.1,1.3-28 c0.8-1.2,1.9-2,3.1-3c2.3,0.1,4.4,0.4,6.5,1.8c0.7,2.4-1.2,3.5-2.3,5c-4.7,6.3-5.3,13.2-1.6,19.9c3.6,6.5,9.6,9.7,17.4,8.9 C178,163.3,179.8,162.5,181.1,163.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 31.8052,
    y1: 158.388,
    x2: 69.4015,
    y2: 158.388
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M39.5,131.8c2,1.3,0.5,3,0,4.2c-5.8,15.1,0.7,29.6,11.5,38c5.5,4.2,11.9,6.3,18.5,7.7 c-1.2,0.4-0.9,2.4-2.6,2.6c-5.5,1.9-10.5,0.1-15.1-2.8c-17.1-11-22.5-23.9-18.9-43.8C33,137,33,136.5,33,136 C34.6,133.9,36.7,132.3,39.5,131.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 82.2004,
    y1: 107.9365,
    x2: 119.5291,
    y2: 107.9365
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M90.7,80.7c-2.8,8.6-4.3,17.2-1.1,26.3c3.2,9.3,9.6,15.5,18.1,20.2c3.8,2,8.5,1.5,11.9,4.6 c-1.3,1.1-2,3.2-4.2,3.4c-15-2-29-14.6-32.2-31.8c-1.1-5.8-1.5-11.6,0.1-17.4C85.2,83.7,87.5,81.4,90.7,80.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 136.3966,
    y1: 55.1694,
    x2: 174.1034,
    y2: 55.1694
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M144.9,28.4c-2.4,8-4,15.8-2.3,24.3c2.3,11.5,14.8,22,24.3,23.9c2.4,0.5,4.9,0.8,7.3,1.2 c-0.7,1.5-1.6,2.6-3.1,3.2c-4.2,1.9-8,0.5-11.7-1.1c-18.6-8-27.2-27.9-20.8-48.1C140.3,30.1,142.2,28.4,144.9,28.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 73.962,
    y1: 118.3818,
    x2: 104.7064,
    y2: 118.3818
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M97.7,138.4c-14-1.8-25.2-16.8-23.6-32.3c0.3-2.8,0.4-5.7,1.9-8.2c2.4,0.3,2.2,2.6,2.6,4 c3,14.7,10.5,25.9,23.7,33.3c0.7,0.4,1.2,0.8,1.6,1.3c0.4,0.4,0.7,0.8,0.8,1.8C102.4,139.3,100.1,138.9,97.7,138.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 125.8065,
    y1: 167.8363,
    x2: 155.6845,
    y2: 167.8363
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M149.8,188.4c-14.7-1.6-26.1-17.8-23.7-34c0.4-2.6,0.5-5.3,2-7.5c2.3,0.3,2,2.2,2.2,3.6 c2.2,14.7,9,26.1,22.2,33.4c0.4,0.3,0.9,0.5,1.3,0.8c0.9,0.8,2,1.8,1.8,3c-0.4,1.6-2,0.8-3.1,0.9 C151.6,188.9,150.7,188.8,149.8,188.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 177.9488,
    y1: 217.9031,
    x2: 209.2329,
    y2: 217.9031
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M202.1,238.5c-12.4-1.3-22.9-12.8-24-26.5c-0.4-5.1-0.4-10.2,2.2-15.1c2.7,0.3,2,2.4,2.3,4 c2,15.4,9.6,27,23.7,34c1.5,0.8,3.4,1.3,2.8,3.8l0,0C206.7,239,204.4,239,202.1,238.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 229.5329,
    y1: 167.3709,
    x2: 259.9402,
    y2: 167.3709
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M254.1,187.4c-14.3-1.2-25.7-16-24.5-31.8c0.3-3,0.3-6.1,1.8-8.8c2.7,0.7,2.6,3.1,3,5 c2.4,13.7,9.7,24,21.6,31.1c1.2,0.7,2.4,1.5,3.4,2.4c0.4,0.4,0.7,0.8,0.7,1.8C258.2,188.2,256.2,187.8,254.1,187.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 193.7884,
    y1: 202.9743,
    x2: 229.3517,
    y2: 202.9743
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M199.3,178.8c1.9-1.8,4.2-1.1,6.3-0.9c0.5,2-0.7,3.5-1.5,4.9c-9.4,16.3,0.5,36.4,20.5,39.3 c1.8,0.3,4.4-0.7,4.7,2.7c-0.3,1.3-0.9,2.3-2,3.1c-5.4,1.5-10.2-1.1-15.4-2.2c-0.5-0.1-1.1-0.4-1.5-0.7c-6.2-4-11.5-9.2-13.9-16.2 C193,198.5,191.9,188.1,199.3,178.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 177.6232,
    y1: 117.7972,
    x2: 209.2124,
    y2: 117.7972
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M202,137.3c-12.1-1.2-22.6-12.3-24-25.3c-0.5-4.7-0.8-9.6,1.2-14.1c2.4-0.3,2.8,1.6,3.2,3.4 c2.7,15.2,10.9,26.4,24.7,33.6c1.1,0.5,2.4,0.9,2,2.7l0,0C206.7,138,204.3,137.9,202,137.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 125.7555,
    y1: 68.227,
    x2: 157.1247,
    y2: 68.227
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M149.8,87.3c-12.3-1.2-22.8-12.8-23.9-26.4c-0.3-4-0.7-8.1,1.1-12c3.1-1.1,3,1.5,3.4,3.2 c1.1,4.9,2.6,9.6,5,14c4,7.1,9.3,12.9,16.6,16.8c1.8,0.9,3.8,1.9,5.1,4C154.6,88.3,152.1,87.7,149.8,87.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 139.4139,
    y1: 256.0068,
    x2: 175.9899,
    y2: 256.0068
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M149.3,229.9c-0.4,4.4-3.5,7.8-4.3,12.3c-3.2,17.7,10.1,32.9,24.5,34.6c2.2,0.3,4.3,1.2,6.5,1.9 c-0.4,1.3-1.1,2.6-2.8,2.3c-2.2,1.2-4.3,1.5-6.6,0.8c-18.3-4.6-31.1-22.1-26-43.8c0.5-2.4,1.5-4.7,3.6-6.3 C145.4,230.3,147.3,229.9,149.3,229.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 200.9068,
    y1: 199.4331,
    x2: 232.4278,
    y2: 199.4331
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M208.9,177.9c1.5,0.3,2.8,0.7,4.3,0.9c3.1,2.6,0,4-1.1,5.7c-5.9,9.3-5.1,18.1,2.4,24.9 c3.6,3.4,8,4.2,12.7,4.2c2.2,0,5.9-1.2,5.1,3.5c0,1.2,0,2.3-1.1,3.1c-13.1,3.9-28.8-6.9-30.2-20.9 C200.4,191.1,201.9,183.5,208.9,177.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.7987,
    y1: 164.8016,
    x2: 62.1249,
    y2: 164.8016
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M53.5,190.3c-0.5-5.1-5.8-4.4-8.6-6.9c-9-8-17-16.3-17.9-29.1c-0.1-2.3-0.1-4.6-2.2-6.3 c0.8-3.4,2.6-6.2,5.1-8.6c3.4,0.3,2.3,3,2.2,4.7c-0.7,10.2,1.9,19.3,8.1,27.6c4.3,5.8,10.2,8.9,16.4,11.9c2,0.9,5.3,0.3,5.5,3.8 C59.4,189.3,56.6,190,53.5,190.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 86.197,
    y1: 207.0226,
    x2: 122.8979,
    y2: 207.0226
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M93.8,180.8c1.9,1.3,0.8,2.7,0.3,4.2c-3.4,9.2-3.4,18.3,1.2,27.2c4.4,8.5,11.7,13.2,20.8,15.5 c2.3,0.5,5,0.5,6.9,2.4c-0.3,0.9-0.9,1.6-1.9,2c-3.9,2-7.5,0.7-11.2-0.7c-19.3-6.9-29.1-30.2-20.5-48.6 C90.6,181.5,92,180.8,93.8,180.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 137.6684,
    y1: 156.1775,
    x2: 175.4509,
    y2: 156.1775
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M144.9,129.6c1.6,1.1,1.2,2.3,0.4,3.6c-8.4,14.4,1.6,35.3,14.6,40.8c5.1,2.2,10.1,3.8,15.6,3.6 c-1.2,2-2.7,3.9-4.9,5c-26-2.4-39.5-28.3-29.8-51.2C141.8,130.4,143.1,129.8,144.9,129.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 257.7515,
    y1: 146.3896,
    x2: 284.6493,
    y2: 146.3896
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M284.5,163.9c-9.3,2.7-17,0.1-22.9-7.4c-4.7-5.9-4.4-12.5-2.4-19.5c1.1-3.8,5.4-5.1,6.2-9 c1.6,0.3,3.1,0.7,4.3,1.9c1.8,2.6,0.1,4.4-1.5,6.1c-4.7,4.3-4.6,9.8-2.4,14.6c2.2,4.7,6.5,8,12.7,7.8 C284.7,158.1,285,158.6,284.5,163.9L284.5,163.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 126.0503,
    y1: 270.0616,
    x2: 154.9776,
    y2: 270.0616
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M154.6,290.3c-16.2,0.9-30.5-15.8-28.3-33.4c0.3-2.3-0.1-4.9,1.5-7c4.3,0.7,1.9,4.7,3.2,6.7 c1.1,6.7,4.3,12.5,8.4,17.9c2.3,2.8,4.9,5.4,7.7,7.8c2,1.5,4.2,2.7,6.1,4.2C154,287.4,155.8,288.2,154.6,290.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 161.2353,
    y1: 250.7731,
    x2: 182.5147,
    y2: 250.7731
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M170.3,235.4c3.4,1.3,5,4.3,6.6,7.3c-0.8,1.1-2.2,1.1-3.2,1.5c-1.9,0.7-3,2-2.2,4c0.8,2.2,2.6,2.7,4.7,1.9 c1.2-0.4,2.3-1.8,3.9-1.1c2,5.5,3.4,11.2,1.3,17.1c-1.1-0.7-1.3-1.8-1.5-2.8c0.1-3-1.6-2.6-3.9-2.6c-11.2,0.1-17.7-8.8-13.7-18.9 C163.6,238.1,166,235.5,170.3,235.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 130.8633,
    y1: 161.5002,
    x2: 167.4976,
    y2: 161.5002
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M131.4,140.4c0.8-1.9,2-3.4,3.8-4.4c4.2,0.9,2.4,4.6,2.4,6.9c0.1,3.8-0.3,7.8,0.5,11.5 c3.4,14,12.4,23,26,27.4c1.8,0.5,4.2,0.1,3.1,3.2c-1.2,1.2-2.6,2-4.3,2.2c-10.4-1.9-18.3-7.7-24.3-16.2 C132.3,161.8,129.6,151.6,131.4,140.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 42.5711,
    y1: 152.4798,
    x2: 75.6169,
    y2: 152.4798
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M73.7,175.7c-0.8-1.2-2-1.3-3.4-1.2c-12.3,0.5-19.9-5.9-25.1-16.2c-5-10.1-2.7-19.5,3.6-28.3 c1.5-1.2,3-0.8,4.6-0.3c0.3-0.1,0.5-0.1,0.8,0.1c0.5,1.6-0.5,2.7-1.3,3.8c-5.7,7.3-6.7,15.2-2.6,23.3c4.3,8.5,11.7,12.4,21.2,12.9 c1.5,0.1,3.5-1.2,4,1.5C75.7,173,75.1,174.5,73.7,175.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 74.296,
    y1: 221.6261,
    x2: 103.4936,
    y2: 221.6261
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M103.5,240.3C86.8,241.2,73,226,74.4,207.9c0.1-1.6,0.4-3.1,0.7-4.7c2.8-1.1,2.8,1.5,3.8,3 c1.2,6.1,3.8,11.3,7,16.4c0.9,1.6,1.6,3.4,3.2,4.4c0.9,0.8,1.8,1.6,2.4,2.6c1.1,2,2.8,3.1,5,3.9 C98.6,235.8,102.8,236.1,103.5,240.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 147.4592,
    y1: 49.0302,
    x2: 179.3109,
    y2: 49.0302
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M178.3,71.3c-10.4,0.7-19.1-2.2-25.7-10.9c-7.7-10.2-5.9-23.2,0.4-31.7c0.5-0.7,1.1-1.3,1.6-2 c0.4,0,0.8,0,1.1,0c4.9,1.3,1.1,3.6,0.5,5.5c-1.5,2-2.4,4.2-3,6.6c-0.7,3.8-0.7,7.5,0,11.3c0.1,0.5,0.3,0.9,0.4,1.5 c0.4,1.8,1.2,3.4,2.3,4.7c5.1,5.7,11,9.6,19.1,9.4c2,0,5.1-0.4,4,3.5C179.1,70.1,179.1,70.9,178.3,71.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 135.4509,
    y1: 258.4624,
    x2: 173.0254,
    y2: 258.4624
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M143.9,231.8c-5.3,13.6-5,26.5,5.1,38c6.3,7.1,14.1,11.3,24,11.3c-1.2,1.3-1.1,3.6-3.5,3.9 c-8.4,1.1-14.3-3.5-20.2-8.4c-8.8-7-12.4-16.7-13.7-27.5c-0.5-4.9,0.9-9.4,2.3-13.9C139.3,233.4,141.1,231.6,143.9,231.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 96.236,
    y1: 202.2385,
    x2: 128.2207,
    y2: 202.2385
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M125.9,225.6c-0.3-2.3-2-2-3.5-2.2c-16.7-1.1-24.3-11.5-26-25.3c-0.5-4.9,0.8-10.2,3.9-14.4 c2.7-3.5,0.8-4-2.3-3.9c3.2-1.5,6.5-0.8,9.7,0.3c0.5,2.3-1.6,3.5-2.3,5.3c-0.3,0.4-0.5,0.8-0.8,1.2c-4.3,5.8-3.6,12.1-1.5,18.5 c0.4,0.9,0.8,1.9,1.2,2.8c3.9,8.2,11.5,10.4,19.7,11c1.3,0.1,2.8-0.7,4,0.3c0.3,0.5,0.3,0.9,0,1.5 C127.9,222.3,127.2,224.1,125.9,225.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 246.0633,
    y1: 151.5488,
    x2: 282.1741,
    y2: 151.5488
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M257.8,126.7c-12.1,13.1-7.5,36.9,10.8,43.7c4.6,1.6,9,0.5,13.6,0.9c-0.4,1.8-1.3,3.2-2.6,4.4 c-5.9,2-11.3,0-16.3-2.6c-17.1-9-22.2-29.2-12-45.4C253.3,126.3,255.6,126.5,257.8,126.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 182.913,
    y1: 210.4245,
    x2: 219.5147,
    y2: 210.4245
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M219.5,234.9c-1.9-0.3-2.4,2.4-4.3,2.2c-6.7-0.3-12-3.8-16.8-7.8c-12.1-10.1-16.8-23.2-15.1-38.8 c1.8-2.6,3.5-5.1,6.3-6.6c1.8,1.8,0.7,3.8,0.4,5.5c-2.2,11,0.7,20.9,7.3,29.9c4.7,6.3,11.6,9,18.3,12.1 C217.2,232.2,219.5,232.2,219.5,234.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 82.5668,
    y1: 209.4717,
    x2: 120.8766,
    y2: 209.4717
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M89.3,182.9c0.7,5-2.2,9.6-2,14.7c0.4,18.2,15.1,34.6,33.6,34.6c-1.2,1.8-2.7,3.1-4.7,3.9 c-3.8-0.5-7.3-1.9-10.9-2.8c-0.9-0.3-1.9-0.8-2.7-1.5c-4.3-3.6-8.8-7-12.7-11.2c-8.4-8.9-7.5-19.8-7-30.7c0-0.8,0.3-1.8,0.3-2.6 C85,185.4,86.8,183.7,89.3,182.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 190.7926,
    y1: 103.2524,
    x2: 227.0608,
    y2: 103.2524
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M193.9,79.6c1.9-1.6,4-2.2,6.5-2.3c1.6,2,0,3.8-0.7,5.4c-2.7,6.9-3,13.9-1.1,20.8c3.1,10.9,10.8,17,21.6,19.5 c2.4,0.5,5.8-0.3,6.9,3.5c-0.3,1.1-0.9,1.8-1.9,2.2c-8.2,1.8-15-1.6-20.9-6.6C190.5,110.6,187.7,96.2,193.9,79.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 78.6906,
    y1: 111.7095,
    x2: 115.2171,
    y2: 111.7095
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M83.1,86.1c1.5,0.9,1.2,2.4,0.9,3.8c-2.2,11.3,1.5,21.6,7.7,30.2c4.9,6.7,12.4,11.3,20.8,13.7 c0.9,0.3,2.2,0.4,2.7,1.5c-1.2,1.2-2.6,2-4.3,2c-9.8-1.5-17.4-7-23-14.8c-6.6-9.2-10.2-19.4-8.9-31C79.9,89.2,81.1,87.5,83.1,86.1z "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 156.1948,
    y1: 248.9043,
    x2: 181.2454,
    y2: 248.9043
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M170.3,235.4c-6.6,4.3-9.3,9.2-7.8,14.6c2,7.7,9.4,11,18.1,8.4c1.1,1.3,0.5,3,0.5,4.6c-2.6,3-6.1,2.8-9.3,2.3 c-7.1-1.1-11.9-5.5-14.4-12c-2.6-6.5-0.8-12.5,3.2-17.9c1.3-1.8,3.2-2.7,5.4-3C168,232.6,169,234.3,170.3,235.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 99.879,
    y1: 98.7366,
    x2: 129.4333,
    y2: 98.7366
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M129.2,114.1c-0.1,1.5,0.1,3.1-1.1,4.3c-9.7,1.1-17.9-1.2-24.5-9.3c-5.9-7.1-5.3-26.7,5.1-30.3 c1.2-0.3,2.3,0.5,3.2,1.1c1.3,2-0.3,3.2-1.2,4.6c-4.3,5.7-6.6,11.9-2.8,18.6c3.9,6.9,10,9.7,17.8,8.8c1.2-0.1,2.4-0.3,3.5,0.5 C129.5,113.1,129.5,113.6,129.2,114.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 132.6261,
    y1: 58.4827,
    x2: 171.0042,
    y2: 58.4827
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M138.5,31.8c1.9,2.2,0.3,4.4-0.3,6.5c-4,18.3,9,38.7,27.5,42.3c1.8,0.3,3.5,0.4,5.3,0.5 c-1.6,1.9-3.5,3.4-5.8,4c-11.3-3-20.6-9.2-26.4-19.1c-5.4-9.6-8.8-20.2-3.6-31.3C136,33.3,137,32.3,138.5,31.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 160.6088,
    y1: 148.0924,
    x2: 182.1082,
    y2: 148.0924
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M169.4,133.1c2,0.8,3.2,2.4,4.4,4c0.4,2.2-1.3,3.1-2.6,4.2c-2.6,2-3.2,4.6-1.8,7.4c1.5,3,4.2,3.4,7.1,2.6 c1.5-0.4,3-1.5,4.3,0c0.7,3.9,2,7.8,0.3,11.7c-0.5-0.3-0.8-0.7-1.1-1.2c-0.7-2.7-2.8-2-4.7-1.9c-9.3,0.1-15.2-5.9-14.8-15.2 C160.9,138.8,164.5,135.4,169.4,133.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 128.2879,
    y1: 164.7918,
    x2: 163.0538,
    y2: 164.7918
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M131.4,140.4c1.3,7,0.8,14.3,3.8,21.2c4,9.2,9.7,16.7,19.1,20.8c3,1.3,5.8,3.1,8.8,4.7 c-4.3,1.9-8.6,3-13.2,1.3c1.6-0.1,3.1-0.1,5.4-0.3c-2.6-3.8-6.7-4.6-9.7-7.1c-9.8-8.2-15.2-18.6-16.4-31.3c-0.1-1.1,0-2.2-0.8-3 C128.8,144.5,129.8,142.3,131.4,140.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 184.461,
    y1: 108.2733,
    x2: 221.6764,
    y2: 108.2733
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M221.7,132.1c-1.1,1.5-2.6,2.3-4.3,2.8c-13.3-3.4-23.2-11.2-28.7-23.9c-3.4-7.8-5.7-16-3.1-24.8 c1.2-2.2,3-3.5,5.1-4.6c1.9,1.8,0.9,3.9,0.7,5.9c-2,13.6,1.5,25.2,12.1,34.4c4.3,3.6,9.3,5.8,14.6,7.4 C219.5,129.8,221.8,129.2,221.7,132.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 189.4799,
    y1: 105.9152,
    x2: 224.9049,
    y2: 105.9152
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M221.7,132.1c-3.4-2-7.3-2-10.8-3.8c-17.9-8.9-23.7-24.4-20.6-42.4c0.3-1.3,0.3-2.8,0.3-4.2 c0.8-1.1,1.9-1.8,3.2-1.9c2.3,3.8-0.8,7-1.3,10.4c-1.5,10.1,1.3,18.6,7.7,26.4c6.5,8,15.1,11.3,24.8,12.4 C224.2,130.2,223.2,131.4,221.7,132.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 75.8696,
    y1: 115.3866,
    x2: 110.9049,
    y2: 115.3866
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M79,91.5c0.9,0.7,0.9,1.8,1.1,2.8c0.7,20.8,10.5,34.9,30,42.2c0.3,0.1,0.5,0.4,0.8,0.7 c-4.3,1.9-8.6,3-13.2,1.2c1.9-0.1,3.8-0.1,6.7-0.3c-4.9-3.1-9.2-5.4-12.8-8.8c-8.6-8.1-13.2-18.1-15-29.6c-0.1-0.7-0.5-1.2-0.8-1.9 C76.4,95.4,77.4,93.2,79,91.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 147.1362,
    y1: 150.4248,
    x2: 179.0892,
    y2: 150.4248
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M156.7,127.9c-3.1,6.1-7,11.5-6.6,19c0.7,12.3,10.5,22.8,22.9,23.3c2,0.1,4.3-0.8,6.1,0.9 c0,0.9-0.3,1.6-1.1,2.2c-19,0-31.4-11.7-30.9-29.1c0.1-4,0.9-8.2,3.4-11.5c2.7-3.8,1.2-4.4-2.4-4.2 C150.8,127.1,153.8,127.6,156.7,127.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 188.1207,
    y1: 208.8625,
    x2: 223.2878,
    y2: 208.8625
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M219.5,234.9c-4.4-2.2-9-4.2-13.5-6.6c-10.5-5.7-15.6-14.8-17.5-26.4c-1.1-6.3,0.3-12.1,1.1-18.2 c0.4-0.3,0.7-0.5,1.1-0.8c3.4-0.1,3.2,2.2,2.6,4.2c-3.4,9.7-0.3,18.2,4.3,26.5c3.4,6.2,8.2,10.8,15,13.2c3.8,1.3,7.8,2.2,10.8,5.3 C222.2,233.5,221,234.5,219.5,234.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 149.983,
    y1: 250.749,
    x2: 180.7065,
    y2: 250.749
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M179.1,272.6c-0.9-1.3-2.4-1.2-3.8-1.2c-10.4,0.3-18.3-3.9-23-13.3c-4-7.8-2.4-18.7,3.9-27.8 c-2.3-0.1-4.2-0.4-6.2-0.5c3.4-1.5,6.6-0.8,10,0.3c1.3,1.9-0.3,3.1-1.1,4.6c-1.6,2.8-3.6,5.5-3.8,8.9c-0.1,2.4,0,4.9,0,7.4 c1.8,10.1,8.4,15.8,18.6,16c2.4,0,5-0.7,7,1.5C180.3,269.8,180.6,271.4,179.1,272.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 234.1747,
    y1: 161.2307,
    x2: 269.5075,
    y2: 161.2307
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M269.5,184.7c-1.2,0.9-2.6,1.6-4,1.6c-15.4-2.4-30.7-21.2-31.3-38.1c-0.1-2.7,0.3-5.3,0.1-8 c0.8-1.6,1.6-3.2,3.2-4.2c3.4,0.7,2.3,3.4,2.4,5.4c0.3,5.1,0.1,10.1,1.8,15.1c3.5,11.3,11.2,18.3,21.4,23.3 C265.5,181.2,269,181.1,269.5,184.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 180.3021,
    y1: 214.512,
    x2: 215.3374,
    y2: 214.512
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M183.3,190.4c2.7,4.2,0.5,8.9,1.5,13.3c3.6,17.2,14.8,27.4,30.6,33.3c-2,0.4-3.9,2-6.2,1.5 c-2.7-3.8-7.5-3.9-10.9-6.9c-9.8-8.6-16.3-18.6-17-31.9c0-1.1,0-2.2-0.9-2.8C180.7,194.4,181.8,192.3,183.3,190.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: 104.4509,
    y1: 96.5953,
    x2: 129.5692,
    y2: 96.5953
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M128.8,112.8c-12.7,2-20.5-2.2-23.7-12.4c-1.9-6.2,0.5-11.3,3.9-16.2c0.9-1.3,2.7-2.3,2.8-4.3 c1.6,0.3,3,1.2,4.2,2.3c1.2,1.6-0.1,2.7-1.2,3.5c-4.4,4.3-6.5,9.6-3.8,15.4c2.7,5.8,7.8,7.7,14.1,6.9 C129.5,107.4,130.4,109.1,128.8,112.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: 182.3297,
    y1: 111.6421,
    x2: 217.3587,
    y2: 111.6421
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M185.6,86.2c3,3.6-0.3,7.7,0.5,11.7c3.4,17.7,12.7,29.6,29.8,35.6c0.5,0.1,0.9,0.9,1.5,1.5 c-1.6,1.2-3.4,1.9-5.3,2c-2.3-2.4-5.8-2.4-8.5-4.2c-15-10.2-22.4-24.1-21.2-42.3C183,88.7,184.1,87.3,185.6,86.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: 208.4749,
    y1: 197.4809,
    x2: 233.3941,
    y2: 197.4809
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M233.4,206.4c0,1.5,0,2.8,0,4.3c-4.6,4.6-10,3-14.8,1.1c-11.2-4.3-13.6-21.2-4.6-28.8 c1.3-1.1,2.8-1.3,4.3-1.8c1.1,0.7,2.2,1.3,3.2,2.2c1.3,2.3-0.8,3.1-1.9,4.2c-4.4,4.6-5.4,9.2-2.8,13.7c2.7,4.9,6.7,6.5,12.9,5.3 C231,206.2,232.2,205.6,233.4,206.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: 96.5884,
    y1: 99.8029,
    x2: 128.1532,
    y2: 99.8029
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M108.7,78.8c-3.9,4.6-7.7,9-7.5,15.8c0.3,14.6,7.5,22.1,22.1,22.5c1.8,0,3.6-0.4,4.9,1.3 c-0.1,1.1,0,2.3-1.1,3.1c-17.9,2.8-32.2-12-30.3-28.8c0.7-5.8,3.8-10.2,6.7-14.8C105.4,77.3,107.1,78.2,108.7,78.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: 46.7126,
    y1: 150.458,
    x2: 76.9578,
    y2: 150.458
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M75.9,171.3c-11.3,0.3-20.8-3.1-26.4-13.6c-4.7-8.6-3.2-18.6,3.5-25.9c0.5-0.7,1.1-1.3,1.6-2.2 c0.7,0,1.5,0.1,2.2,0.1c2.7,1.9,0.7,3.4-0.4,4.7c-5.9,6.9-6.2,14.6-2.2,22.1c3.8,7.1,10.5,10,18.6,9.7c1.3,0,2.8-0.7,4,0.5 C77.1,168.6,77.1,170.1,75.9,171.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_57_",
    gradientUnits: "userSpaceOnUse",
    x1: 95.0772,
    y1: 100.5527,
    x2: 127.0751,
    y2: 100.5527
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M103.5,77.9c1.3,2.2-0.7,3.4-1.5,4.6c-9.3,14.6-1.8,33.3,14.8,37.5c3.4,0.8,7.1-1.1,10.2,1.5 c-0.1,0.8-0.1,1.6-0.9,2c-16.3,0.9-28.3-9.4-30.7-23.9c-1.3-7.5,1.6-13.7,5.3-20.1c-1.1-1.5-2.7-0.4-3.8-0.9 C98.9,77.2,101.2,77.6,103.5,77.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_58_",
    gradientUnits: "userSpaceOnUse",
    x1: 196.8608,
    y1: 100.2904,
    x2: 230.2611,
    y2: 100.2904
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M230.2,121.3c-0.1,0.4-0.3,0.7-0.4,1.1c-9.6,3.8-17.2-0.5-24.1-6.5c-9.4-8.4-11.5-24.1-5.1-35 c0.9-1.8,2-3.4,4-4c1.1,0,2.2,0,3.1,0c0.7,1.8-0.3,3.1-1.2,4.4c-8.5,12.7-4.6,32.1,15.1,36.8c2.6,0.7,5.3,0.4,7.8,1.6 C230.2,119.9,230.4,120.5,230.2,121.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_59_",
    gradientUnits: "userSpaceOnUse",
    x1: 240.8141,
    y1: 154.7705,
    x2: 276.9189,
    y2: 154.7705
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M243.8,130.7c1.2-1.3,2.6-2,4.4-2.2c1.2,2.3,0.1,4.4-0.7,6.6c-6.1,17.9,5.9,36.9,23.6,40.6 c2,0.4,5.3-0.5,5.8,3.1c-0.4,1.1-1.1,1.8-2.2,2.2c-14.8,0.5-30.3-12.8-33.3-28.4C240.3,145,240.5,137.7,243.8,130.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_60_",
    gradientUnits: "userSpaceOnUse",
    x1: 156.7274,
    y1: 147.134,
    x2: 181.2561,
    y2: 147.134
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M169.4,133.1c-1.2,1.3-2.3,2.7-3.5,3.9c-4.7,4.7-5.4,9.3-2.2,15.2c2.8,5.4,7.5,8.1,13.7,5.9 c5.3-1.8,3.5,1.2,3.5,3.5c-7.8,3.6-17.4,0.8-21.7-6.3c-4.6-7.8-2.8-18.5,3.9-23.4c0.9-0.7,2-0.7,3-0.9 C167.2,131.7,168.3,132.5,169.4,133.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_61_",
    gradientUnits: "userSpaceOnUse",
    x1: 108.2902,
    y1: 98.0996,
    x2: 129.8557,
    y2: 98.0996
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M128.8,112.8c-0.1-1.9,1.2-4.2-3-3.6c-8.4,1.2-14-1.9-16.6-8.1c-2.4-5.9-0.4-11.6,5.8-17.1 c0.5-0.4,0.7-1.2,0.9-1.8c2.2,1.1,4.2,2.3,4.6,5c-0.7,1.2-1.8,1.6-3,2.2c-4.4,2.2-3.5,5.9-3.1,9.7c0.3,0.4,0.4,0.8,0.5,1.2 c2,3.8,5.4,4,9,3.5c2.6-0.8,5.5-2.2,5.5,2.6c0.1,2.6,0.7,5.3-0.7,7.7C129.1,113.6,129,113.2,128.8,112.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_62_",
    gradientUnits: "userSpaceOnUse",
    x1: 231.3728,
    y1: 164.2314,
    x2: 265.3302,
    y2: 164.2314
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M234.2,140.4c2.7,3.8,0.5,8.2,1.5,12.3c3.6,15.4,12.8,25.9,27,32.2c0.9,0.4,2.2,0.4,2.7,1.5 c-3.6,1.5-7.3,2.4-11.2,0.9c1.6-0.1,3.1-0.1,5.5-0.4c-6.3-4.3-12.5-7.7-17-13.2c-5.8-7.3-8.8-15.6-10.4-24.5 c-0.1-0.8-0.5-1.6-0.9-2.4C231.9,144.5,232.7,142.3,234.2,140.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_63_",
    gradientUnits: "userSpaceOnUse",
    x1: 244.975,
    y1: 153.1824,
    x2: 279.7486,
    y2: 153.1824
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st62",
    d: "M277.1,178.8c-3.1-1.1-6.2-2.2-9.4-3.1c-10.9-2.8-22.5-15.8-22.6-28c-0.1-6.7,1.5-12.8,3.4-19.1 c0.8-1.1,2-1.1,3.1-0.9c0.1,4.7-3.2,8.5-3.9,13.2c-2,15.4,9.6,31.4,24.4,33.7c2.6,0.4,5.3,0.8,7.8,1.2 C279.1,176.9,278.3,178.1,277.1,178.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_64_",
    gradientUnits: "userSpaceOnUse",
    x1: 215.8326,
    y1: 95.2747,
    x2: 233.1246,
    y2: 95.2747
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M224.6,85.3c5.4,4.3,7.4,10.4,8.5,16.8c-5.4,3.8-8.5,4-12.4,1.2c-4-2.8-5.8-7-4.4-11.5 C217.5,88,219.9,85.2,224.6,85.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_65_",
    gradientUnits: "userSpaceOnUse",
    x1: 200.7653,
    y1: 99.0095,
    x2: 231.2707,
    y2: 99.0095
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M230.2,121.3c-4-0.9-8.1-1.6-12.1-3c-18.6-6.1-21.7-27.9-11.6-39.2c0.5-0.7,0.8-1.5,1.2-2.3 c1.2-0.1,2.3-0.1,3.4,0.7c0.8,2.6-1.3,3.9-2.4,5.5c-9,14.7-0.1,31.7,17,32.6c2,0.1,5.1-1.1,5.7,2.7 C231.4,119.5,231.1,120.5,230.2,121.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_66_",
    gradientUnits: "userSpaceOnUse",
    x1: 179.2241,
    y1: 113.9329,
    x2: 212.4442,
    y2: 113.9329
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M182.5,90.4c1.5,7.1,1.5,14.6,4.6,21.2c4.9,10,11.5,18.5,22.4,22.4c1.6,0.5,3.9,0.1,2.7,3.1 c-1.1,0.1-2,0.3-3.1,0.4c-11.3-5.5-20.2-13.3-25.1-25.3c-1.2-3.1-2.3-6.3-2.7-9.6c-0.1-1.8-0.1-3.6-2-4.6 C179.5,95.1,180.7,92.7,182.5,90.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_67_",
    gradientUnits: "userSpaceOnUse",
    x1: 195.8105,
    y1: 101.5555,
    x2: 229.7557,
    y2: 101.5555
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M204.6,76.7c-8.9,12.4-9,24.3,0.1,36.1c6.2,8.1,15.1,10.5,25.1,9.4c-0.7,1.6-1.3,3.2-2.8,4.3 c-3.8-2.8-8.6-1.9-12.9-3.6c-18.2-7.5-22.4-29.5-14.1-43.5c0.3-0.5,0.3-1.3,0.4-2C201.6,76.4,203.1,76.5,204.6,76.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_68_",
    gradientUnits: "userSpaceOnUse",
    x1: 206.3508,
    y1: 198.0626,
    x2: 233.3694,
    y2: 198.0626
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M218.3,181.1c-10.4,7.5-11.6,19.4-2.6,27.5c5.3,4.6,11.5,3.8,17.5,2.2c0.1,2.3,0.4,4.6-1.1,6.5 c-1.2-3.9-4.6-2.4-6.7-2.2c-9,1.2-20.9-9.7-18.9-21.3c0.7-3.9,2-7.8,4.9-10.9c1.1-1.1,2.7-2,1.5-3.9 C215.3,178.5,216.3,181,218.3,181.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_69_",
    gradientUnits: "userSpaceOnUse",
    x1: 153.4865,
    y1: 249.272,
    x2: 181.3801,
    y2: 249.272
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M153.5,251c0-2.8,0-5.7,0-8.4c2.8-4,3.9-9.3,8.6-12c1.3,0.5,2.7,1.1,4,1.6c-7.7,5.7-10.5,14.3-7.1,21.6 c4.2,8.6,11.9,11.7,22.1,9c0.1,1.1,0.1,2.2,0.3,3.4l-0.3-0.1c-9,4.9-20.8-1.5-24.1-8C155.8,255.8,155,253.2,153.5,251z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_70_",
    gradientUnits: "userSpaceOnUse",
    x1: 135.1602,
    y1: 158.3335,
    x2: 170.4651,
    y2: 158.3335
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M167.4,185c-0.1-1.6-1.2-1.9-2.6-2.2c-16.8-3.9-29.9-20.6-28.4-38.8c0.3-2.6,1.2-5.7-1.2-8.1 c1.3-2,3.1-3.5,5.5-4.3c1.2,3.9-1.1,7.4-1.5,11c-1.9,18.5,9.6,34.8,26.7,37.7c1.6,0.3,3.1,1.5,4.6,2.3 C169.7,183.9,168.7,184.7,167.4,185z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_71_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.9193,
    y1: 161.6349,
    x2: 66.8412,
    y2: 161.6349
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st70",
    d: "M62,187.3c-2-2-4.9-2-7.1-3.1c-16.3-6.7-22.6-20.2-24.5-36.5c-0.3-2.8,2.3-5.8-0.4-8.5 c0.5-1.5,1.8-2.6,3.1-3.2c1.5,0.9,1.5,2.3,1.1,3.8c-2.2,8.1-1.1,16.2,2.3,23.3c5.9,12.5,16,20.2,30.5,21.2 C65.2,185.3,63.6,186.2,62,187.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_72_",
    gradientUnits: "userSpaceOnUse",
    x1: 212.0503,
    y1: 96.1275,
    x2: 233.394,
    y2: 96.1275
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M224.6,85.3c-8.6,4.2-10.2,11.3-3.6,16.6c2.4,2,5.1,3,8.2,1.2c1.2-0.7,2.6-1.2,4-0.9c0,1.8,0.1,3.5,0.1,5.3 c-5.1,3-10.1,3.1-15-0.9c-1.6-1.8-3.5-3.4-4.7-5.4c-0.5-1.2-0.9-2.4-1.3-3.6c-0.4-1.5-0.4-3.1-0.1-4.7c0.9-7,3.1-9.6,8.6-10 C222.9,82.3,223.2,84.8,224.6,85.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_73_",
    gradientUnits: "userSpaceOnUse",
    x1: 79.6584,
    y1: 212.8405,
    x2: 114.2331,
    y2: 212.8405
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st72",
    d: "M83.3,187.3c2.3,5.1,0.5,10.4,1.1,15.6c0.5,6.6,2.4,12.7,7.4,17.4c2.4,5.3,7,8,11.7,10.6 c0.4,0.8,1.2,1.1,2.2,1.1c1.6,1.5,3.5,2.2,5.7,2.6c1.5,0.3,3.4,0.3,2.8,2.7c-0.5,0.7-1.2,1.1-2.2,1.1c-20.9-3.2-37.2-28-31-48.1 C81.7,189.1,81.8,187.7,83.3,187.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_74_",
    gradientUnits: "userSpaceOnUse",
    x1: 152.9854,
    y1: 46.894,
    x2: 181.1957,
    y2: 46.894
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st73",
    d: "M160.9,27.8c1.6,0.1,3.1,0.7,4.3,1.9c0.5,2-1.3,2.7-2.3,3.8c-5,5.7-6.3,12.4-3.2,18.2 c3.5,6.3,8.9,9.4,16.3,8.6c1.6-0.1,3.5-0.9,5.1,0.4c0.1,1.9,0.3,3.8-0.9,5.4c-4-0.7-8.1,0.5-12.1-0.9c-7.5-2.7-13.1-7.3-14.6-15.4 C152,41.2,153.6,33.4,160.9,27.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_75_",
    gradientUnits: "userSpaceOnUse",
    x1: 237.5714,
    y1: 158.8052,
    x2: 272.7416,
    y2: 158.8052
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st74",
    d: "M269.5,184.7c-1.1-2-3.2-2-5-2.7c-15.5-6.1-27.1-20.5-25.9-38.9c0.1-2.3,1.1-5-1.1-7c0.7-1.5,1.8-2.6,3.2-3.2 c3.1,0.8,1.5,3,1.2,4.6c-2.3,13.7,1.6,25.3,12,34.8c4,3.8,9,6.1,14.3,7.7c1.6,0.5,4,0.3,4.4,2.8 C271.5,183.4,270.5,184.1,269.5,184.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_76_",
    gradientUnits: "userSpaceOnUse",
    x1: 60.5217,
    y1: 147.6411,
    x2: 77.7823,
    y2: 147.6411
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "M69.7,138.3c2.4,1.5,3.5,3.9,4.2,6.5c-1.5,1.1-4.2-0.4-4.9,2.2c-0.3,0.8,0,1.5,0.7,1.9c2.4,1.2,3.2-1.3,5-1.9 c0.3-0.1,0.7,0,0.9,0.1c0.5,2.8,2.4,5.4,2.2,8.4c-2.2,1.2-4.6,2-7,2.2c-4.4,0.4-8.4-2.4-9.7-6.7c-1.5-4.7,0.3-10.1,4-12.1 C66.6,137.7,68.1,137.3,69.7,138.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_77_",
    gradientUnits: "userSpaceOnUse",
    x1: 190.443,
    y1: 206.5746,
    x2: 224.9133,
    y2: 206.5746
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M223.2,232.2c-9.3-2.6-18.9-5.7-24.7-13.9c-3.4-4.6-5.4-10.5-7.3-16.3c-1.9-6.2,0.1-10.9,1.2-16.3 c0.3-1.6-0.8-2.2-1.9-2.7c0.8-1.2,1.9-1.9,3.4-2c2.7,0.7,3,0.8,1.9,3.9c-2,5.7-2.2,11.3-1.2,17.1c1.6,10.2,7.4,17.7,16.4,22.6l0,0 c3.5,1.3,6.9,3.2,10.9,3.4c1.6,0,3.1,0.7,3,2.8C224.2,231.1,223.7,231.6,223.2,232.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_78_",
    gradientUnits: "userSpaceOnUse",
    x1: 156.7113,
    y1: 45.634,
    x2: 181.2453,
    y2: 45.634
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M181.1,60.6c-12,3.1-21.2-1.2-23.9-11.7c-2-8.2,1.8-14.3,8-19.3c0.9,0,1.6,0.3,2.2,1.1 c1.5,2.6-0.9,3.5-2.2,4.7c-4.2,4.3-4.9,9.2-2.6,14.7c2.3,5.1,5.8,7,12.4,7c2,0,4.2-1.2,6.2,0.3C181.2,58.5,181.2,59.6,181.1,60.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_79_",
    gradientUnits: "userSpaceOnUse",
    x1: 130.8199,
    y1: 60.167,
    x2: 165.3447,
    y2: 60.167
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st78",
    d: "M135.3,34.5c-1.2,7.7-1.2,15.4,1.3,22.9c3.9,12,12.3,19.4,23.4,24.3c1.9,0.8,4.2,1.2,5.3,3.2 c-0.7,0.3-1.5,0.7-2.2,0.9c-14.3-2.6-23-11.9-28.8-24.3c-3.2-7-4.3-14.6-3-22.4C132.1,37.3,133.5,35.7,135.3,34.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_80_",
    gradientUnits: "userSpaceOnUse",
    x1: 262.934,
    y1: 146.8123,
    x2: 285.48,
    y2: 146.8123
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st79",
    d: "M284.5,163.9c0.4-3.5-1.3-5-4.6-4.3c-6.5,1.5-10.5-2.6-14.7-6.2c-3.2-2.8-2.8-13.3,0.1-16.7 c1.8-2,4.7-3.5,4.2-6.9c1.3,0.1,2.4,0.9,3.2,2c1.3,2.4-0.5,3.4-1.9,4.9c-3.9,4.3-4.7,8.9-2.3,13.5c2.4,4.7,6.6,5.3,11.2,4.9 c1.9-0.1,3.8-1.2,5.5,0.4C285.4,158.2,285.9,161.2,284.5,163.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_81_",
    gradientUnits: "userSpaceOnUse",
    x1: 49.9944,
    y1: 148.9376,
    x2: 76.9479,
    y2: 148.9376
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M76.7,167.1c-9.2,2.4-19-1.2-23.7-8.6c-4.7-7.5-3.8-17.9,2.6-24.9c0.9-1.1,2.2-1.9,1.1-3.5 c1.1,0.4,2.2,0.7,3.2,1.1c1.6,3.8-2.7,4.7-3.4,7.5c-0.9,1.6-1.6,3.4-2.2,5.3c-0.7,2.3-0.8,4.4-0.1,6.7c0.4,1.6,1.1,3,1.9,4.3 c0.3,0.4,0.4,0.8,0.5,1.2c0.7,2.4,2.6,3.8,4.6,4.9c0.4,0.3,0.8,0.5,1.2,0.8c2.4,1.8,5.3,1.6,8.1,1.8c2.2,0,4.6-0.5,6.5,1.3 C76.9,165.6,76.8,166.3,76.7,167.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_82_",
    gradientUnits: "userSpaceOnUse",
    x1: 128.9617,
    y1: 267.5604,
    x2: 161.1383,
    y2: 267.5604
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M154.6,290.3c-1.6-3.9-6.2-4.3-8.5-7.3c-2-3-4.6-5.4-7.4-7.4c-4.3-5.4-8.1-10.9-8.5-18.1 c-1.1-3.5-0.1-7.3-1.2-10.8c0.4-0.7,0.8-1.3,1.2-2c3.1,0.4,2.3,3.1,2.4,4.9c2.2,17.1,10.6,29.5,26.7,36.5c0.5,0.3,0.9,0.5,1.2,0.9 c0.5,0.7,0.8,1.3,0.5,2.3C158.9,290.3,156.9,290.7,154.6,290.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_83_",
    gradientUnits: "userSpaceOnUse",
    x1: 133.5533,
    y1: 260.7178,
    x2: 169.3871,
    y2: 260.7178
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st82",
    d: "M137.7,235.1c1.5,1.2,0.4,2.6,0.1,3.9c-2.4,12.1-0.1,23.2,8.2,32.6c6.2,7,14,11.6,23.3,13.2 c-0.9,0.5-1.6,1.8-3,1.3c-10.1,0.1-17.1-5.8-23.3-12.8c-8.9-10.1-10.8-22.2-8.9-35.2C135.2,237,136.1,235.8,137.7,235.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_84_",
    gradientUnits: "userSpaceOnUse",
    x1: 151.6673,
    y1: 48.4811,
    x2: 180.0325,
    y2: 48.4811
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M160.9,27.8c-3.1,5.7-6.9,10.6-6.6,17.8c0.7,11.7,10,20.3,21.7,19.3c1.5-0.1,3.5-2,4,1.2c0,1.2,0,2.3-1.1,3.2 c-0.8-3.5-3.6-2.2-5.7-2.2c-8.2-0.1-14.3-4.3-18.9-10.6c-0.8-1.3-0.9-3.1-2.2-4.3c0-0.4,0-0.7,0-1.1c-0.8-4.3-0.8-8.5,0-12.8 c0-2.7,0.7-5,3.2-6.3c1.2-1.6,2.4-3.2,4.3-4.2C160.2,27.6,160.6,27.8,160.9,27.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_85_",
    gradientUnits: "userSpaceOnUse",
    x1: 155.3673,
    y1: 147.2976,
    x2: 181.3011,
    y2: 147.2976
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st84",
    d: "M166.3,131c-5.5,4.3-9.7,9.4-8.2,17c1.6,8.5,6.1,12.5,14.7,14.3c2.8,0.5,5.5-1.3,8.2-0.5 c0.1,0.4,0.3,0.8,0.3,1.2c0.1,0.3,0,0.7-0.1,0.9c-10.2,2.7-18.7-0.1-23.3-8.4c-3.2-5.9-4.3-16.3,3.6-23.6c0.7-0.5,1.1-1.3,1.6-2.2 C164.4,129.6,165.3,130.3,166.3,131z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_86_",
    gradientUnits: "userSpaceOnUse",
    x1: 203.5215,
    y1: 97.8073,
    x2: 232.304,
    y2: 97.8073
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M231.4,118.3c-1.2-1.9-3.1-1.3-4.9-1.3c-9.4,0.1-16.3-4.2-20.5-12.4c-4.6-8.8-2.6-17.1,3.2-24.7 c0.7-0.8,1.2-1.6,1.9-2.6c0.9-0.1,1.6,0,2.3,0.8c0.9,2.2-0.8,3.2-1.9,4.6c-6.5,8.2-7.5,21.4,6.6,28.8c0.5,0.1,0.9,0.4,1.5,0.7 c2.3,1.3,4.7,1.2,7.1,1.2c1.9,0,3.9-0.1,5.4,1.3C232.5,116.2,232.3,117.4,231.4,118.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_87_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.43,
    y1: 147.0274,
    x2: 77.7561,
    y2: 147.0274
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st86",
    d: "M69.7,138.3c-6.5,2-9.2,6.5-7.4,12.3c1.5,4.4,5.5,6.6,10.5,5.3c1.6-0.4,3.2-1.6,5-0.4c0,0.4,0,0.7,0,1.1 c-3.6,4-9.4,4.7-14.3,1.5c-1.6-1.1-3-2.6-4.4-3.8c-5-7.1-2.7-15,6.1-20.1C67.1,134.9,68.5,136.6,69.7,138.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_88_",
    gradientUnits: "userSpaceOnUse",
    x1: 132.2672,
    y1: 263.1776,
    x2: 166.4226,
    y2: 263.1776
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M134.2,238.2c3.4,3.8,0.3,8.1,0.8,12.1c2.2,19,12.8,30,30.5,35.4c0.3,0.1,0.7,0.3,0.9,0.4 c-0.3,1.2-0.9,2-2.3,1.9c-1.3-0.3-3,0.3-4.2-0.9c-5.3-3.1-10.6-5.7-15.2-10.2c-10.2-10.2-13.6-22.5-12.1-36.5 C132.9,239.6,133.1,238.6,134.2,238.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_89_",
    gradientUnits: "userSpaceOnUse",
    x1: 77.7363,
    y1: 214.5923,
    x2: 111.9829,
    y2: 214.5923
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st88",
    d: "M81,190.1c0.1,8.5-0.1,16.8,3.8,24.8c4.9,10.2,12.8,16.8,23,21c1.5,0.5,3.1,0.9,4.2,2.2 c-0.7,0.3-1.5,0.7-2.2,0.9c-11.9-1.8-19.5-9.2-25.5-18.7c-4.9-7.8-7.5-16.3-6.3-25.7C78.6,192.8,79.2,191.2,81,190.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_90_",
    gradientUnits: "userSpaceOnUse",
    x1: 76.8313,
    y1: 217.5094,
    x2: 109.6922,
    y2: 217.5094
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M78,194.7c2.2,2.8,0.7,6.2,1.2,9.2c3.4,17.8,13.9,29,30.5,35.2c-2,0.8-4,1.6-6.3,1.1 c-1.9-2.8-5.7-3.2-7.4-6.2c-2.4-0.7-4-2.2-5.3-4.3c-1.1-0.4-1.8-1.1-2.2-2.2c-1.6-0.9-2-3-3.2-4.3c-4.3-4.9-7-10.5-7.4-17 c-1.3-3.1-1.1-6.3-0.9-9.6C77.4,196.2,77.8,195.4,78,194.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_91_",
    gradientUnits: "userSpaceOnUse",
    x1: 240.5896,
    y1: 156.7839,
    x2: 275.0323,
    y2: 156.7839
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st90",
    d: "M272.6,182.7c-1.2-0.7-2.4-1.5-3.8-1.8c-19.9-5-31.7-24.5-27.4-44.1c0.3-1.3,0.7-2.8-0.7-3.9 c0.7-1.2,1.8-1.9,3.1-2.2c1.3,3.1-0.7,5.8-1.1,8.6c-3.5,21.8,13.3,38.5,29.4,40.4c1.1,0.1,2.2,0.1,2.8,1.2 C274.4,181.9,273.7,182.5,272.6,182.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_92_",
    gradientUnits: "userSpaceOnUse",
    x1: 193.0214,
    y1: 201.6353,
    x2: 211.0254,
    y2: 201.6353
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M211,224.5c-7.4-1.5-15.1-11-17.1-20.2c-1.5-6.9-1.1-13.6,0.9-20.2c0.3-0.9,1.9-2.8-0.8-3.2 c1.5-1.2,3.2-2.3,5.3-2c-3.8,6.7-4.4,14.4-3.9,21.7c0.7,8.4,5.3,15.2,11.9,20.5C208.6,222.1,210.2,222.7,211,224.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_93_",
    gradientUnits: "userSpaceOnUse",
    x1: 159.8114,
    y1: 44.6372,
    x2: 181.2453,
    y2: 44.6372
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st92",
    d: "M181.2,57.4c-11.7,3-17.8,0.3-20.8-9.2c-1.8-5.7,0-10,3.8-14c1.1-1.1,3-1.5,3-3.5c1.3,0.3,2.3,1.1,3.1,2.2 c0.4,2.3-1.6,2.8-2.8,4c-4,4.3-4.9,8.4-2.4,12.9c2,3.9,6.5,5.5,11.9,4.3c1.3-0.3,2.7-0.9,4-0.1C181.2,55.2,181.2,56.3,181.2,57.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_94_",
    gradientUnits: "userSpaceOnUse",
    x1: 128.9975,
    y1: 63.2077,
    x2: 163.0539,
    y2: 63.2077
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "M131.3,39.3c2.4,4.2,0.5,8.9,1.6,13.5c3.8,15.5,12.5,26.1,27.5,31.5c0.9,0.4,1.8,1.1,2.7,1.6 c-0.9,0.5-1.9,1.2-3.2,1.1c-16.4-6.2-26.7-17.7-29.8-35.2c-0.5-3.1-1.5-6.2-0.8-9.3C129.9,41.5,130.6,40.4,131.3,39.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_95_",
    gradientUnits: "userSpaceOnUse",
    x1: 127.1984,
    y1: 65.3885,
    x2: 159.9545,
    y2: 65.3885
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M129.4,42.6c1.5,6.7,1.9,13.7,4.7,20.2c4.3,10.2,12.5,16.6,21.8,21.8c1.3,0.8,2.7,1.6,4,2.4 c-3.4,0.9-6.6,1.9-10,0.3c1.9-0.1,3.8-0.1,6.9-0.3c-11.5-5.4-19.3-12.9-24.1-23.4c-1.8-3.9-2.8-8-3.5-12.1c-0.3-1.3-0.5-2.4-2-2.6 C127.1,46.5,128.2,44.5,129.4,42.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_96_",
    gradientUnits: "userSpaceOnUse",
    x1: 214.018,
    y1: 195.8677,
    x2: 233.3941,
    y2: 195.8677
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "st95",
    d: "M233.4,206.4c-11.2,6.3-20.5-3.4-19.3-12.1c0.4-2.8,1.8-4.9,3.6-6.9c1.2-1.3,3.6-1.9,3.9-4.2 c0.7,0.7,1.5,1.2,2.2,1.9c1.3,2-0.4,2.8-1.5,3.8c-3.4,2.8-5.4,6.1-3.2,10.5c1.9,3.9,5.1,5,10.8,3.6c1.2-0.3,2.4-0.8,3.5,0.3 C233.3,204.3,233.4,205.4,233.4,206.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_97_",
    gradientUnits: "userSpaceOnUse",
    x1: 216.7182,
    y1: 195.14,
    x2: 233.2594,
    y2: 195.14
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "st96",
    d: "M233.3,203.2c-1.3,0.5-2.6,0.9-3.9,1.5c-4.6,1.6-9.6-0.3-11.7-4.3c-2-3.9-0.5-9.4,3.1-12.1 c1.2-0.8,3-1.2,3.1-3.2c1.5,0.7,2.3,2,3.1,3.4c0.5,2.3-1.8,2.2-2.7,3.2c-1.8,1.8-3.8,3.4-2,6.2c1.8,2.8,4,3.8,7,1.9 c0.8-0.5,1.8-1.2,3-0.5C232.5,200.5,232.9,201.9,233.3,203.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_98_",
    gradientUnits: "userSpaceOnUse",
    x1: 208.8615,
    y1: 96.0733,
    x2: 233.2593,
    y2: 96.0733
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M220.7,82.9c-4.4,1.8-7.3,4.7-7.7,9.7c-0.8,1.8-0.8,3.5,0,5.3c1.2,0.8,1.1,2,1.1,3.2c1.1,1.8,2.4,3.2,4.3,4.3 c4.4,4.2,9.7,2.4,14.8,2.2c0,0.4,0,0.7,0,1.1c-1.2,2.4-3.5,3-5.8,3.2c-7.3,1.1-15.5-5-17.9-12.3c-2.4-7.4,1.9-17.4,8.8-19.4 C219.1,81,219.9,81.9,220.7,82.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_99_",
    gradientUnits: "userSpaceOnUse",
    x1: 199.9936,
    y1: 200.1065,
    x2: 231.3728,
    y2: 200.1065
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "M208.9,177.9c-2.7,5.8-6.5,10.8-6.6,17.9c-0.4,13.1,12.4,26,27.4,23.7c0.5-0.1,1.2,0.5,1.8,0.7 c0,0.9-0.1,1.8-0.9,2.3c-4.6-0.4-9.2-0.3-13.5-2c-15.8-5.9-22.1-26.3-12.3-40c0.8-1.2,1.9-2.2,3.2-2.7 C208.1,177.9,208.5,177.9,208.9,177.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_100_",
    gradientUnits: "userSpaceOnUse",
    x1: 167.0324,
    y1: 145.0917,
    x2: 180.9757,
    y2: 145.0917
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M181,151.2c-1.2,0.4-2.3,0.7-3.5,1.1c-3.8,1.6-7,1.1-9.2-2.4c-2.3-3.9-1.5-7.4,2.3-10.1 c1.2-0.8,2.6-1.3,3.1-2.7C177.9,141,179.4,146.2,181,151.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_101_",
    gradientUnits: "userSpaceOnUse",
    x1: 100.6516,
    y1: 200.5108,
    x2: 129.1141,
    y2: 200.5108
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M128,220.5c-0.1-0.4-0.1-0.8-0.3-1.2c-4-0.4-8.2,0.1-12.3-1.5c-5.4-2-9.6-5.1-12.1-10.2 c-0.8-0.4-1.1-1.2-1.1-2.2c-2.6-7.1-2.3-13.9,2.2-20.2l0,0c1.2-1.8,2.6-3.5,4.4-4.6c0.7,0.1,1.2,0.3,1.9,0.4c0,4.3-5,6.1-5.5,10.1 c-2.2,5.1-1.5,10.1,1.2,14.8c4.9,6.7,11.3,10,19.7,8.8c0.9-0.1,1.8,0,2.6,0.4C129.1,216.8,129.6,218.8,128,220.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_102_",
    gradientUnits: "userSpaceOnUse",
    x1: 103.5257,
    y1: 198.5486,
    x2: 128.9617,
    y2: 198.5486
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "st101",
    d: "M104.6,190.4c0.3-4.4,4.4-6.2,6.3-9.6c1.1,0.4,2,0.8,3.1,1.3c0.3,2.2-1.8,2.8-2.8,4.2 c-6.7,8.4-5.5,18.2,3.1,24.3c2.7,1.9,5.5,1.9,8.5,2c2,0,4.2-0.8,6.2,0.3c-0.1,0.7-0.1,1.5-0.3,2.2c-9.3,3-16,0.5-23.2-8.6 C103.4,201.2,102.8,195.9,104.6,190.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_103_",
    gradientUnits: "userSpaceOnUse",
    x1: 53.7551,
    y1: 148.0848,
    x2: 77.8909,
    y2: 148.0848
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "st102",
    d: "M65.2,134.1c-1.3,3.4-5.4,4.7-6.5,8.5c-1.2,3.8-2,7.4,1.1,10.6c5.1,6.3,8.1,7.3,16.2,5 c0.7-0.3,1.3-0.3,1.9,0.3c0,0.7,0,1.3,0,2.2c-5,4.9-15.9,3.1-20.9-5.1c-0.9-1.5-1.6-3.1-2.3-4.7c-2.6-5.7,0.5-10,3.1-14.6 c1.3-1.6,2.8-3.2,5.3-3.4C63.7,133.3,64.4,133.7,65.2,134.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_104_",
    gradientUnits: "userSpaceOnUse",
    x1: 199.2067,
    y1: 201.3193,
    x2: 230.4297,
    y2: 201.3193
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M207.8,177.9c-15.9,18.1-3.1,38.9,12,43.1c3.5,0.9,7.4-1.1,10.6,1.8c-0.1,0.8-0.3,1.6-1.1,2 c-2-2.4-5-1.1-7.5-1.6c-21-5.1-29.6-27.8-16-45.1C206.3,177.9,207,177.9,207.8,177.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_105_",
    gradientUnits: "userSpaceOnUse",
    x1: 114.9735,
    y1: 95.765,
    x2: 128.827,
    y2: 95.765
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M122.8,88.1c3.1,3.4,5,7.4,6.1,11.9c-2.6,3.5-5.9,4.3-9.7,2.4c-3.1-1.5-4.6-4.3-4-7.8 C115.8,90.4,118.7,88.7,122.8,88.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_106_",
    gradientUnits: "userSpaceOnUse",
    x1: 129.7702,
    y1: 263.9788,
    x2: 159.685,
    y2: 263.9788
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M132.5,240.5c1.2,1.6,0.8,3.4,0.7,5.1c-0.7,18.1,7.7,30.9,23.4,39.1c1.2,0.7,2.6,1.2,3.1,2.7 c-15.5-5.3-24-16.4-27.8-31.9c-0.8-3.5-0.3-7.4-2.2-10.6C130.3,243,131.3,241.6,132.5,240.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_107_",
    gradientUnits: "userSpaceOnUse",
    x1: 162.4877,
    y1: 44.6371,
    x2: 181.1105,
    y2: 44.6371
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M181.1,54.2c-8.9,5.1-17.9,0.3-18.6-8.5c-0.4-6.1,3.8-9.4,7.8-12.7c0.8,1.1,1.5,2,2.3,3.1 c-0.9,1.3-2.6,1.8-3.6,2.8c-4.4,4.2-3.4,9.7,2.4,13.2c3,1.6,5.5-0.3,8.1-1.3c0.5-0.1,0.9,0,1.3,0.3C181,52.1,181.1,53.2,181.1,54.2 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_108_",
    gradientUnits: "userSpaceOnUse",
    x1: 106.3095,
    y1: 198.2793,
    x2: 129.905,
    y2: 198.2793
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M129.9,208.6c0,0.7,0,1.3,0,2.2c-4.4,3.2-10.8,3.6-15.2,0.7c-5.5-3.6-9.2-8.5-8.2-15.4 c0.8-5.5,3.1-10.5,8.8-12.9c0.7,0.4,1.3,0.8,2,1.2c0.4,2-1.5,2.7-2.4,3.8c-5.8,6.1-6.1,10.9-0.9,17.8 C118.6,210.8,124.4,209,129.9,208.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_109_",
    gradientUnits: "userSpaceOnUse",
    x1: 105.297,
    y1: 198.1184,
    x2: 129.9947,
    y2: 198.1184
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M115.2,182.9c-2.8,2.8-6.1,5.4-7.3,9.4c-1.9,6.2-0.7,11.7,4.4,16.2c5.4,4.7,11.2,5.5,17.5,2.3 c0.1,0.8,0.3,1.6-0.8,2c-11,3.4-17.5-0.1-22-8c-4.2-7.3-0.9-16.8,6.9-22.6C114.4,182.5,114.8,182.7,115.2,182.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_110_",
    gradientUnits: "userSpaceOnUse",
    x1: 206.505,
    y1: 96.5182,
    x2: 233.1246,
    y2: 96.5182
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M215.2,78.7c0.4,0.1,0.7,0.1,1.1,0.3c1.3,2-0.5,3-1.6,3.9c-6.1,5.1-6.5,14-3.1,19.8 c3.9,6.7,10.8,9.6,19.1,7.7c0.8-0.1,1.8-0.5,2.4,0.1c-0.4,0.7-0.7,1.5-1.1,2.2c-4.6,3.1-9.2,1.2-13.6,0l0,0 C202.1,105,204,85.3,215.2,78.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_111_",
    gradientUnits: "userSpaceOnUse",
    x1: 220.027,
    y1: 195.2189,
    x2: 232.1813,
    y2: 195.2189
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "st110",
    d: "M232.2,199c-2.2,1.2-3.8,3.9-6.9,3c-2.6-0.8-4-2.7-5-5c-0.9-2.4,0.5-4,2-5.5c1.3-1.2,3.1-2.2,4.7-3.2 C229.9,191.3,231.6,194.9,232.2,199z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_112_",
    gradientUnits: "userSpaceOnUse",
    x1: 169.4196,
    y1: 247.3967,
    x2: 180.0325,
    y2: 247.3967
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "st111",
    d: "M180,249c-0.9,0.8-1.9,1.5-3,2.3c-1.9,1.3-3.6,0.9-5.4-0.1c-1.8-1.2-2.6-3-2.2-5c0.4-2.2,1.9-3.4,4.2-3.5 c1.1-0.1,2.2,0,3.2,0C178.7,244.4,179.8,246.6,180,249z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_113_",
    gradientUnits: "userSpaceOnUse",
    x1: 167.3685,
    y1: 44.8292,
    x2: 179.8978,
    y2: 44.8292
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "st112",
    d: "M176,39.3c2.2,2.2,3.2,4.7,3.9,7.5c-1.2,3.4-3.6,4.6-7,4.3c-2.8-0.3-4.4-2-5.3-4.6c-0.8-2.8,0.3-5.1,2.6-7 C171.9,38.1,174,38,176,39.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_114_",
    gradientUnits: "userSpaceOnUse",
    x1: 113.6442,
    y1: 96.6173,
    x2: 130.1866,
    y2: 96.6173
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "st113",
    d: "M122.8,88.1c-0.8,0.7-1.6,1.3-2.4,1.8c-4.2,1.9-5.4,5.3-3.2,8.9c2.2,3.8,5.5,4.3,9.4,2 c0.7-0.4,1.6-0.5,2.4-0.9c0.5,2,1.6,4,1.1,6.3c-1.1-3.2-3.1-2.3-5.1-1.1c-4.2-0.5-8.4-0.9-10.6-5.3l0,0c-1.1-4.4-1.2-8.8,3.2-11.7 c1.1-0.4,2.3-0.8,3.4-1.1C121.7,87,122.4,87.3,122.8,88.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_115_",
    gradientUnits: "userSpaceOnUse",
    x1: 208.6866,
    y1: 95.4822,
    x2: 233.2257,
    y2: 95.4822
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M233.1,110.6c-8.1,2.6-15.4,1.3-20.9-5.7c-4.3-5.5-4.4-11.6-1.8-17.9c1.3-3.2,5.1-4.4,5.8-8 c0.7,0.4,1.3,0.7,2,1.1c-2.3,3.1-5.9,5.1-7.1,9c-2,6.6-0.8,12.4,4.4,17.1c5.4,4.7,11.2,5.5,17.5,2.2 C233.3,109.1,233.3,110,233.1,110.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_116_",
    gradientUnits: "userSpaceOnUse",
    x1: 265.7885,
    y1: 144.2271,
    x2: 285.2735,
    y2: 144.2271
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "st115",
    d: "M285.3,155.4c-2.4,0.4-4.9,0.8-7.3,1.1c-5.1,0.5-8.9-1.5-11-6.2c-2.3-4.9-1.1-10.9,2.7-14.4 c1.3-1.2,3.1-1.8,3.1-3.9c1.6,0.7,2.7,1.6,3.2,3.4c-0.8,1.2-2.3,1.6-3.4,2.6c-3.1,2.8-5.1,5.9-3.2,10.1c1.9,4.3,6.1,6.5,10.6,5.7 c1.3-0.3,2.7-0.9,4-0.1C284.6,153.9,285,154.7,285.3,155.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_117_",
    gradientUnits: "userSpaceOnUse",
    x1: 109.854,
    y1: 197.3196,
    x2: 129.905,
    y2: 197.3196
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "st116",
    d: "M128.8,205.4c0.4,0.7,0.7,1.3,1.1,2c-6.1,3.2-11.9,3.2-17-1.8c-5.4-9.4-3.8-15.4,5.5-20.6 c0.4,0.3,0.8,0.7,1.1,0.9c1.2,2.2-0.5,3.2-1.8,4.3c-3.5,3-4.7,6.6-2.7,10.8c1.9,4,5.8,5.3,11.3,4.2 C127.2,205.2,128,205,128.8,205.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_118_",
    gradientUnits: "userSpaceOnUse",
    x1: 268.2246,
    y1: 145.0709,
    x2: 284.3302,
    y2: 145.0709
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "st117",
    d: "M277.5,136.1c0.3,0.3,0.5,0.5,0.8,0.9c0.5,1.9-1.1,2.4-2.2,3.2c-2.4,1.6-3.9,3.9-2.6,6.6 c1.3,2.7,3.9,3.2,6.7,2.2c1.2-0.5,2.6-1.2,3.9,0c0,0.7,0.1,1.3,0.1,2c-4.2,3.6-7.5,4-11.5,1.6c-3.5-2.2-5.7-6.9-4.2-10.5 C270.3,138.5,272.5,135.2,277.5,136.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_119_",
    gradientUnits: "userSpaceOnUse",
    x1: 165.7437,
    y1: 44.796,
    x2: 180.9758,
    y2: 44.796
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "st118",
    d: "M176,39.3c-2.2-0.1-4,0.1-5.8,1.9c-2.2,2.2-2.2,4.3-0.7,6.7c1.8,3,4.4,2.4,7,1.6c1.2-0.4,2.3-1.6,3.4-2.6 c0.4,1.3,0.7,2.8,1.1,4.2h-0.4h-0.4c-2.8,1.6-5.7,2.7-8.9,1.5c-4.3-1.5-6.1-4.6-5.4-9c0.7-4.2,3.4-6.7,7.8-7.3 C175,36.8,175.5,38.1,176,39.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_120_",
    gradientUnits: "userSpaceOnUse",
    x1: 205.4932,
    y1: 95.4046,
    x2: 218.3019,
    y2: 95.4046
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "st119",
    d: "M215.2,78.7c-3.1,4.2-7,7.4-7.7,13.3c-1.1,9.7,4,15.5,10.8,20.6c-8.8-1.9-14.7-12.9-12.3-22.4 c1.2-4.9,4.3-8.4,7.1-12.1C214,78.4,214.5,78.6,215.2,78.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_121_",
    gradientUnits: "userSpaceOnUse",
    x1: 267.3592,
    y1: 145.0332,
    x2: 284.5997,
    y2: 145.0332
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "st120",
    d: "M277.5,136.1c-6.5,1.9-9.3,6.3-7.4,11.5c2,5.7,7.4,6.9,14.6,3.5c-0.1,0.7-0.1,1.5-0.3,2.2 c-5.1,2.7-9.7,2.7-13.9-1.9c-2.6-2.7-3.9-5.8-2.6-9.2c1.3-3.6,3.5-7,8.2-7.1C276.5,135.4,276.9,135.7,277.5,136.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_122_",
    gradientUnits: "userSpaceOnUse",
    x1: 153.4865,
    y1: 259.6667,
    x2: 181.1773,
    y2: 259.6667
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "M153.5,251c2.2,0.1,2,2.2,2.7,3.5c4.7,10.1,14.1,14.4,24.9,11.5c0.1,0.8,0.1,1.6-0.7,2.3 c-5.5-0.5-11.2,0.9-16.6-2.2C157.9,262.6,154.6,257.8,153.5,251z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_123_",
    gradientUnits: "userSpaceOnUse",
    x1: 112.7846,
    y1: 196.6872,
    x2: 129.0964,
    y2: 196.6872
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "st122",
    d: "M128.8,205.4c-4.3,2.6-8.4,3.1-12.5-0.5c-3.5-3.1-4-6.7-3.1-10.9c0.8-3.6,5.4-4.4,6.3-8 c0.7,0.7,1.5,1.5,2.2,2.2c0.7,2-1.3,2.2-2.3,3c-3,2.4-5,5.3-3.2,9c1.8,3.6,5.1,4.3,8.9,3.6c1.3-0.3,2.6-1.3,4-0.5 C129,203.9,129,204.7,128.8,205.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_124_",
    gradientUnits: "userSpaceOnUse",
    x1: 271.4704,
    y1: 143.8227,
    x2: 284.3302,
    y2: 143.8227
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "M284.3,148.9c-1.5,0.5-3,1.2-4.4,1.6c-3.4,1.1-6.1-0.4-7.7-3.1c-1.6-3-0.4-5.8,2.2-8c1.2-0.9,3-1.2,3.8-2.7 c0.5,0.8,1.2,1.8,1.8,2.6c0.4,1.5-0.9,1.8-1.8,2c-2,0.8-3.6,1.9-2.4,4.3c1.3,2.3,3.2,1.3,5,0.3c0.8-0.5,1.5-0.8,2.4-0.4 C283.7,146.9,283.9,148,284.3,148.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_125_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.6131,
    y1: 157.1545,
    x2: 77.8908,
    y2: 157.1545
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "st124",
    d: "M55.5,150c6.1,11.6,10.5,13.7,22.4,10.6c0,0.4,0,0.7,0,1.1c-4.2,3.5-10.4,3.5-17,0l0,0 c-2.2-1.5-3.9-3.2-5.3-5.4c0-0.4,0-0.7,0-1.1C54.6,153.5,54,151.7,55.5,150z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_126_",
    gradientUnits: "userSpaceOnUse",
    x1: 113.9158,
    y1: 196.8326,
    x2: 129.0964,
    y2: 196.8326
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "M129.1,203.2c-5.8,3.6-11.5,2.7-14.3-2.2c-2.4-4.2,0.1-9,6.9-12.8c0.4,0.4,0.7,0.8,1.1,1.1 c0.3,2.6-2.7,2.4-3.6,4c-2.2,2.4-2.3,5.3-0.3,7.5c1.9,2.3,4.6,2.2,7.1,0.7c0.9-0.5,1.9-1.1,3-0.5C129,201.9,129,202.5,129.1,203.2z "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_127_",
    gradientUnits: "userSpaceOnUse",
    x1: 273.7781,
    y1: 144.2477,
    x2: 283.2522,
    y2: 144.2477
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M283.3,145.8c-0.8,0.7-1.8,1.2-2.4,1.9c-1.5,1.3-3.1,1.6-4.9,0.5c-1.3-0.9-2.4-2.2-2.2-3.9 c0.3-1.9,1.5-3.1,3.2-3.8c0.9-0.3,2.2,0,2.8-0.9C282,141.1,282.8,143.4,283.3,145.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_128_",
    gradientUnits: "userSpaceOnUse",
    x1: 116.0057,
    y1: 198.1571,
    x2: 128.9617,
    y2: 198.1571
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "M129,201.2c-0.8,0.5-1.8,1.2-2.6,1.8c-3.4,2.3-6.7,1.5-8.9-1.5c-1.9-2.8-2.4-6.2,0.9-8.9 c0.7-0.5,1.3-0.7,2-0.3c-0.4,9.3-0.4,9.3,7.4,5.7C128.3,199,128.6,200.1,129,201.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_129_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.1567,
    y1: 147.3009,
    x2: 75.7348,
    y2: 147.3009
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "st128",
    d: "M75.7,146.9c-0.7,0.8-1.3,1.6-2,2.4c-1.5,1.6-3.2,2.4-5.1,1.1c-1.8-1.2-1.6-3.1-1.1-4.9 c0.7-2,2.6-2.3,4.4-1.8c0.7,0.1,1.3,0.5,1.9,0.8C74.9,145.1,75.5,145.9,75.7,146.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_130_",
    gradientUnits: "userSpaceOnUse",
    x1: 108.9341,
    y1: 195.3228,
    x2: 118.4511,
    y2: 195.3228
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "st129",
    d: "M118.5,185c-3.9,3.6-8.6,6.7-7.5,13.3c0.4,2.6,2.2,4.4,2.3,7c0.3,0.3,0.4,0.5,0.3,0.7 c-0.1,0.3-0.3,0.4-0.3,0.4c-5.7-5.8-5.7-12.7-0.1-18.5c1.3-1.3,2.8-2.6,4.3-3.8C117.6,184.5,118,184.7,118.5,185z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_131_",
    gradientUnits: "userSpaceOnUse",
    x1: 118.284,
    y1: 196.9082,
    x2: 127.8837,
    y2: 196.9082
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "st130",
    d: "M127.9,198c-1.9,1.9-3,5.3-6.6,3.9c-1.8-0.7-2.7-2-3-4c-0.3-2.2,1.2-3.5,2.2-5.3c1.5-1.3,2.8-1.1,4.3,0 C126.4,194,127.1,196.1,127.9,198z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_132_",
    gradientUnits: "userSpaceOnUse",
    x1: 210.8906,
    y1: 227.6632,
    x2: 227.0608,
    y2: 227.6632
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "M224.8,230.7c-0.8-1.6-2.3-1.9-4-1.9c-3.8,0-7-1.5-9.8-4.2c5.4,1.1,10.8,2.2,16.2,3.2 C226.7,229.1,225.8,230,224.8,230.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_133_",
    gradientUnits: "userSpaceOnUse",
    x1: 165.2216,
    y1: 44.6706,
    x2: 173.6992,
    y2: 44.6706
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "st132",
    d: "M173.7,36.4c-3.6,1.5-6.9,3.8-7.3,8.1c-0.4,3.8,2,6.1,5.3,7.7c0.3,0.3,0.4,0.5,0.3,0.7 c-0.1,0.3-0.1,0.4-0.3,0.4c-5.8-0.9-6.9-5-6.3-9.8c0.4-4.4,3.1-6.9,7.5-7.3C173.2,36.1,173.4,36.1,173.7,36.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_134_",
    gradientUnits: "userSpaceOnUse",
    x1: 113.061,
    y1: 208.0965,
    x2: 129.905,
    y2: 208.0965
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "st133",
    d: "M113.1,206.4c0-0.4,0-0.7,0-1.1c5.1,4.7,11,3.2,16.8,2.2c0,0.4,0,0.8,0,1.1 C122.9,212.1,118.3,211.6,113.1,206.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_135_",
    gradientUnits: "userSpaceOnUse",
    x1: 59.8341,
    y1: 156.6498,
    x2: 77.8908,
    y2: 156.6498
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M77.9,158.5c-4.9,1.9-9.8,2.6-14.4-0.4c-1.8-1.1-3.5-2.4-3.6-4.9c5.3,5.3,11,7.5,17.9,3.2 C77.9,157.1,77.9,157.8,77.9,158.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_136_",
    gradientUnits: "userSpaceOnUse",
    x1: 60.9121,
    y1: 163.3362,
    x2: 78.0535,
    y2: 163.3362
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "st135",
    d: "M60.9,161.7c5.7,1.2,11.3,3.5,17,0c0.1,1.2,0.5,2.4-0.8,3.2c-3.6,0-7.3,0.1-10.9-0.1 C63.9,164.7,62,163.9,60.9,161.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_137_",
    gradientUnits: "userSpaceOnUse",
    x1: 153.4864,
    y1: 236.1526,
    x2: 162.1105,
    y2: 236.1526
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "M162.1,230.6c-2.8,4-5.8,8.1-8.6,12c0.7-5,4.6-8.4,6.3-12.8C160.8,229.8,161.6,229.9,162.1,230.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_138_",
    gradientUnits: "userSpaceOnUse",
    x1: 218.4367,
    y1: 113.8739,
    x2: 232.1813,
    y2: 113.8739
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "st137",
    d: "M218.4,112.8c4.6-0.3,9.2,2.4,13.6,0c0,0.7,0.1,1.5,0.1,2.2C227.6,114.1,222.5,116.6,218.4,112.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_139_",
    gradientUnits: "userSpaceOnUse",
    x1: 55.522,
    y1: 134.8197,
    x2: 63.0681,
    y2: 134.8197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "st138",
    d: "M63.1,132.9c-1.5,1.1-2.8,2.2-4.3,3.4c-0.9,0.8-1.2,2.8-3.2,2.2c0-3.2,4.2-4,4.2-7.3 C60.9,131.7,62,132.2,63.1,132.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_140_",
    gradientUnits: "userSpaceOnUse",
    x1: 105.6497,
    y1: 234.5355,
    x2: 116.2951,
    y2: 234.5355
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "st139",
    d: "M114.1,237.2c-0.8-1.9-2.4-2.2-4.2-2.2c-2.2,0-3.4-1.5-4.3-3.1c3.5,1.5,7.7,1.1,10.6,4 C115.5,236.5,114.8,236.9,114.1,237.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_141_",
    gradientUnits: "userSpaceOnUse",
    x1: 75.0611,
    y1: 201.6562,
    x2: 78.119,
    y2: 201.6562
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M77.1,196.9c1.9,3.1,0.5,6.3,0.9,9.6c-1.3-0.7-0.8-3.2-3-3.2C75.2,200.9,75.7,198.8,77.1,196.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_142_",
    gradientUnits: "userSpaceOnUse",
    x1: 127.6142,
    y1: 252.1206,
    x2: 130.2095,
    y2: 252.1206
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "st141",
    d: "M128.8,246.7c2.6,3.4,0.7,7.1,1.2,10.8c-2.4-2,0.4-5.7-2.4-7.5C128.2,248.9,127.3,247.4,128.8,246.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_143_",
    gradientUnits: "userSpaceOnUse",
    x1: 118.4511,
    y1: 190.9434,
    x2: 124.9191,
    y2: 190.9434
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "st142",
    d: "M124.9,192.6c-1.5,0-3,0-4.3,0c-0.7,0-1.5,0-2.2,0c0.5-2.3,3.2-1.6,4.3-3.2C124,190,124.6,191.1,124.9,192.6 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_144_",
    gradientUnits: "userSpaceOnUse",
    x1: 155.4747,
    y1: 29.225,
    x2: 159.8198,
    y2: 29.225
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "st143",
    d: "M159.8,27.6c-1.1,1.8-2.4,3.2-4.3,4.2c-0.4-1.8,3.1-3.4,0-5.1C157.1,26.5,158.6,26.8,159.8,27.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_145_",
    gradientUnits: "userSpaceOnUse",
    x1: 104.5663,
    y1: 182.3867,
    x2: 109.0185,
    y2: 182.3867
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "st144",
    d: "M109,180.4c-1.1,2-2.6,3.5-4.4,4.6c-0.1-2.4,2.3-3.4,3.1-5.3C108.1,180.2,108.6,180.3,109,180.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_146_",
    gradientUnits: "userSpaceOnUse",
    x1: 159.8198,
    y1: 288.3318,
    x2: 163.9971,
    y2: 288.3318
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M159.8,287.3c1.5,0.1,3.1-0.4,4.2,0.9c-0.9,0.7-1.9,1.3-3.2,1.1C160.6,288.6,160.2,288,159.8,287.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_147_",
    gradientUnits: "userSpaceOnUse",
    x1: 46.7632,
    y1: 129.362,
    x2: 53.7703,
    y2: 129.362
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M53.8,129.6c-1.5,0.1-3.1,0.1-4.6,0.3c-0.8-0.1-1.6-0.3-2.4-0.3C49.1,128.6,51.3,128.6,53.8,129.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_148_",
    gradientUnits: "userSpaceOnUse",
    x1: 202.1318,
    y1: 238.8901,
    x2: 209.1389,
    y2: 238.8901
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "st147",
    d: "M202.1,238.5c2.3,0,4.6,0,7,0C206.7,239.6,204.4,239.5,202.1,238.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_149_",
    gradientUnits: "userSpaceOnUse",
    x1: 201.997,
    y1: 137.7422,
    x2: 209.0041,
    y2: 137.7422
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M202,137.3c2.3,0,4.7,0,7,0C206.7,138.5,204.3,138.4,202,137.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_150_",
    gradientUnits: "userSpaceOnUse",
    x1: 138.6638,
    y1: 279.2731,
    x2: 146.0751,
    y2: 279.2731
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "st149",
    d: "M138.7,275.6c3.8,1.2,6.2,3.8,7.4,7.4C143.1,281,140.7,278.5,138.7,275.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_151_",
    gradientUnits: "userSpaceOnUse",
    x1: 90.6922,
    y1: 231.9125,
    x2: 95.9475,
    y2: 231.9125
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "st150",
    d: "M90.7,229.8c1.8,1.5,3.5,2.8,5.3,4.3C93,234.2,91.1,232.9,90.7,229.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_152_",
    gradientUnits: "userSpaceOnUse",
    x1: 85.4369,
    y1: 225.5746,
    x2: 88.671,
    y2: 225.5746
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "st151",
    d: "M85.4,223.4c1.9,0.8,2.3,2.7,3.2,4.3C86.1,227.3,85.7,225.4,85.4,223.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_153_",
    gradientUnits: "userSpaceOnUse",
    x1: 151.1957,
    y1: 44.6706,
    x2: 152.4085,
    y2: 44.6706
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "M152.4,38.3c0,4.3,0,8.5,0,12.8C150.8,46.8,150.8,42.4,152.4,38.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_154_",
    gradientUnits: "userSpaceOnUse",
    x1: 152.4085,
    y1: 54.1706,
    x2: 154.5882,
    y2: 54.1706
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M152.4,52c1.9,0.8,2.3,2.4,2.2,4.3C153.2,55.2,152.5,53.8,152.4,52z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_155_",
    gradientUnits: "userSpaceOnUse",
    x1: 103.4683,
    y1: 213.8275,
    x2: 127.8836,
    y2: 213.8275
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "st154",
    d: "M103.5,207.5c5.7,7.5,12.9,11.7,22.6,10.8c0.5,0,1.2,0.7,1.8,0.9c-6.9,3.2-19.7-3-23.2-7.8 C103.8,210.1,103.4,208.9,103.5,207.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_156_",
    gradientUnits: "userSpaceOnUse",
    x1: 99.9677,
    y1: 195.2555,
    x2: 104.5717,
    y2: 195.2555
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "st155",
    d: "M104.6,185.1c-2.8,6.5-3.9,13.2-2.2,20.2C98.5,197.8,99.3,190.5,104.6,185.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_157_",
    gradientUnits: "userSpaceOnUse",
    x1: 91.7702,
    y1: 225.5072,
    x2: 103.4936,
    y2: 225.5072
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "st156",
    d: "M103.5,230.8c-5.7-1.6-10.1-4.6-11.7-10.6C95,224.5,99.9,227.1,103.5,230.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_158_",
    gradientUnits: "userSpaceOnUse",
    x1: 114.139,
    y1: 102.6391,
    x2: 124.7844,
    y2: 102.6391
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "st157",
    d: "M114.1,100c2.8,3.1,6.9,4,10.6,5.3C120.3,105.4,115.8,105.6,114.1,100z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_159_",
    gradientUnits: "userSpaceOnUse",
    x1: 112.9394,
    y1: 94.1244,
    x2: 117.3731,
    y2: 94.1244
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "st158",
    d: "M117.4,88.3c-3.1,3.4-3.6,7.4-3.2,11.7C111.8,93.9,112.8,90.7,117.4,88.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_160_",
    gradientUnits: "userSpaceOnUse",
    x1: 223.1445,
    y1: 94.8609,
    x2: 228.9473,
    y2: 94.8609
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "st159",
    d: "M226.3,97.8c-1.8-0.5-3.2-1.3-3.1-3.1c0-1.6,1.3-3,3.1-2.8c1.6,0.3,2.7,1.6,2.7,3.4 C228.9,96.9,227.7,97.6,226.3,97.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_161_",
    gradientUnits: "userSpaceOnUse",
    x1: 214.1247,
    y1: 103.0854,
    x2: 218.4367,
    y2: 103.0854
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "M218.4,105.2c-2.6-0.3-3.9-1.8-4.3-4.3C216,102,217.4,103.5,218.4,105.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_162_",
    gradientUnits: "userSpaceOnUse",
    x1: 211.8339,
    y1: 95.2024,
    x2: 213.0467,
    y2: 95.2024
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "st161",
    d: "M213,97.8c-1.6-1.8-1.6-3.5,0-5.3C213,94.3,213,96.1,213,97.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_163_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.7597,
    y1: 145.7343,
    x2: 58.7561,
    y2: 145.7343
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "M55.5,138.3c1.1-0.7,2.2-1.3,3.2-2.2c-1.5,4.6-5.7,8.4-3.2,13.9c0,1.8,0,3.5,0,5.4c-1.9-0.8-2.3-2.4-2.2-4.3 c-0.8-2.4-0.8-5,0-7.4C53.4,141.5,53.9,139.6,55.5,138.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_164_",
    gradientUnits: "userSpaceOnUse",
    x1: 55.6568,
    y1: 159.0073,
    x2: 60.9121,
    y2: 159.0073
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "st163",
    d: "M55.7,156.3c2.2,1.3,3.9,3.1,5.3,5.4C57.9,161.2,56.2,159.4,55.7,156.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_165_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.187,
    y1: 147.3513,
    x2: 53.5008,
    y2: 147.3513
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "st164",
    d: "M53.5,143.6c0,2.4,0,5,0,7.4C51.7,148.6,51.7,146.1,53.5,143.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_166_",
    gradientUnits: "userSpaceOnUse",
    x1: 170.694,
    y1: 146.1322,
    x2: 176.9426,
    y2: 146.1322
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "st165",
    d: "M174.1,149.7c-2-0.5-3.2-1.8-3.4-3.6c-0.3-2,0.8-3.4,3-3.5c1.9-0.1,3.1,0.8,3.2,2.7 C177.1,147.6,175.7,148.8,174.1,149.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_167_",
    gradientUnits: "userSpaceOnUse",
    x1: 102.6906,
    y1: 198.3548,
    x2: 105.6497,
    y2: 198.3548
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "st166",
    d: "M104.6,190.4c-0.4,5.4-0.4,10.6,1.1,15.9C102.3,201.3,101.6,195.9,104.6,190.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_168_",
    gradientUnits: "userSpaceOnUse",
    x1: 119.8201,
    y1: 95.9625,
    x2: 124.6496,
    y2: 95.9625
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "st167",
    d: "M124.6,95.7c0,1.3-0.4,2.6-1.8,2.7c-1.6,0.3-2.7-0.9-3-2.3c-0.5-1.8,0.9-2.4,2.4-2.6 C123.7,93.5,124.6,94.2,124.6,95.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_169_",
    gradientUnits: "userSpaceOnUse",
    x1: 171.5431,
    y1: 52.5141,
    x2: 180.0325,
    y2: 52.5141
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "M171.5,53.1c0-0.4,0-0.7,0-1.1c3,0.7,5.7-0.8,8.5-1.1C177.7,53.6,175,55.2,171.5,53.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_170_",
    gradientUnits: "userSpaceOnUse",
    x1: 223.0057,
    y1: 195.7327,
    x2: 228.9617,
    y2: 195.7327
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "st169",
    d: "M226.3,192.7c2,0.3,2.8,1.5,2.7,3.2c-0.1,1.9-1.2,3-3.1,2.8c-2,0-3-1.5-2.8-3.1 C223.2,194,224.6,193.1,226.3,192.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_171_",
    gradientUnits: "userSpaceOnUse",
    x1: 171.9345,
    y1: 44.6288,
    x2: 175.8552,
    y2: 44.6288
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "st170",
    d: "M175.9,44.3c-0.1,1.6-0.7,2.4-2,2.2c-1.1-0.1-2-0.8-1.9-2s0.9-1.8,2.2-1.8C175.6,42.7,175.6,43.7,175.9,44.3 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_172_",
    gradientUnits: "userSpaceOnUse",
    x1: 276.1929,
    y1: 144.6649,
    x2: 279.8077,
    y2: 144.6649
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "M277.9,142.8c0.9,0,1.6,0.5,1.9,1.5c0.3,1.2-0.4,2-1.6,2.2c-0.9,0.1-1.6-0.5-1.9-1.5 C276,143.8,276.8,143.1,277.9,142.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_173_",
    gradientUnits: "userSpaceOnUse",
    x1: 119.4798,
    y1: 197.0747,
    x2: 125.6751,
    y2: 197.0747
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "st172",
    d: "M120.5,195.8c1.1-2,2.3-2.6,4-0.7c1.1,1.1,1.6,2.3,0.7,3.8c-0.9,1.3-2.4,1.6-3.8,0.9 C119.7,198.9,118.6,197.5,120.5,195.8c0.3,0.3,0.5,0.5,0.8,0.7C121,196.2,120.7,196.1,120.5,195.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_174_",
    gradientUnits: "userSpaceOnUse",
    x1: 172.9999,
    y1: 146.0798,
    x2: 175.4682,
    y2: 146.0798
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "st173",
    d: "M174.1,144.9c0.8,0,1.5,0.3,1.3,1.2c0,0.7-0.5,1.3-1.3,1.2c-0.4,0-0.9-0.5-1.1-0.9 C172.9,145.4,173.3,144.9,174.1,144.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_175_",
    gradientUnits: "userSpaceOnUse",
    x1: 225.0395,
    y1: 195.8706,
    x2: 227.7345,
    y2: 195.8706
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "st174",
    d: "M227.7,195.3c0,1.3-0.7,2-1.5,2.2c-0.8,0.1-1.2-0.5-1.2-1.2c0-0.9,0.4-1.8,1.3-1.9 C226.8,194.3,227.3,195,227.7,195.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_176_",
    gradientUnits: "userSpaceOnUse",
    x1: 120.4723,
    y1: 197.2094,
    x2: 123.9889,
    y2: 197.2094
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "M120.5,195.8c1.3,0.1,3-0.3,3.5,1.5c0.1,0.3-0.8,1.3-1.2,1.3C121,198.6,120.6,197.3,120.5,195.8L120.5,195.8 z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasheel);
export default __webpack_public_path__ + "static/media/tasheel.7675297b022717d4aff019cf698da8da.svg";
export { ForwardRef as ReactComponent };